import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        dashboard: 'Tableau de bord',
        exhibitors: 'Exposants',
        partners: 'Partenaires',
        pavilions: 'Pavillons',
        information: 'Informations',
        events: 'Événements',
        news: 'Actualités',
        subscriptions: 'Abonnements',
        appointments: 'Rendez-vous',
        chat: 'Messagerie',
        networking: 'Réseautage',
        profile: 'Mon Profil',
        accommodation: 'Hébergement'
      },
      menu: {
        pavilions_desc: 'Découvrez les pavillons du salon',
        events_desc: 'Calendrier des événements',
        news_desc: 'Actualités et nouveautés',
        subscriptions_desc: 'Gérez vos abonnements',
        accommodation_desc: 'Hôtels partenaires & tarifs préférentiels'
      },
      exhibitor_levels: {
        basic_9: '9m² Basique',
        standard_18: '18m² Standard',
        premium_36: '36m² Premium',
        elite_54plus: '54m²+ Élite'
      },
      auth: {
        login: 'Connexion',
        register: 'Inscription',
        logout: 'Déconnexion',
        email: 'Email',
        password: 'Mot de passe',
        remember_me: 'Se souvenir de moi',
        forgot_password: 'Mot de passe oublié?'
      },
      appointments: {
        book: 'Réserver',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        quota_reached: 'Quota atteint ({{current}}/{{max}})',
        booking_success: 'Rendez-vous réservé avec succès',
        no_slots: 'Aucun créneau disponible',
        calendar: 'Calendrier des Rendez-vous',
        meeting_with: 'RDV avec {{name}}',
        no_appointments_date: 'Aucun rendez-vous pour cette date.'
      },
      common: {
        days: {
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mer',
          thu: 'Jeu',
          fri: 'Ven',
          sat: 'Sam',
          sun: 'Dim'
        },
        events: 'Événements',
        connections: 'Connexions',
        impressions: 'Impressions',
        interactions: 'Interactions',
        loading: 'Chargement...',
        error: 'Erreur',
        success: 'Succès',
        save: 'Enregistrer',
        saving: 'Enregistrement...',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        search: 'Rechercher',
        view: 'Voir',
        view_all: 'Voir tout',
        load_more: 'Voir plus',
        download: 'Télécharger',
        upload: 'Téléverser',
        close: 'Fermer',
        confirm: 'Confirmer',
        back: 'Retour',
        next: 'Suivant',
        previous: 'Précédent',
        filter: 'Filtrer',
        export: 'Exporter',
        import: 'Importer',
        refresh: 'Actualiser',
        warning: 'Attention',
        close_error: 'Fermer le message d\'erreur',
        back_to_dashboard: 'Retour au Tableau de Bord',
        sending: 'Envoi...',
        error_401: 'Accès non autorisé',
        error_401_desc: 'Vous devez être connecté pour accéder à cette page.',
        error_403: 'Accès interdit',
        error_403_desc: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette ressource.'
      },
      actions: {
        accept: 'Accepter',
        reject: 'Refuser',
        open: 'Ouvrir',
        close: 'Fermer',
        add: 'Ajouter',
        view_details: 'Voir les détails',
        schedule_meeting: 'Planifier un RDV',
        refresh: 'Actualiser',
        access: 'Accéder',
        manage: 'Gérer',
        view: 'Voir',
        edit: 'Modifier',
        copy: 'Copier',
        connect: 'Connecter',
        message: 'Message',
        view_all: 'Voir tout'
      },
      errors: {
        oops: 'Oups !',
        unexpected_error: 'Une erreur inattendue s\'est produite. Nous en sommes désolés.',
        error_message: 'Message d\'erreur',
        view_stack_trace: 'Voir la trace d\'erreur',
        reload_page: 'Recharger la page',
        back_to_home: 'Retour à l\'accueil',
        accept_appointment: 'Erreur lors de l\'acceptation du rendez-vous',
        reject_appointment: 'Erreur lors du refus du rendez-vous',
        unregister_event: 'Erreur lors de la désinscription de l\'événement',
        unknown_user_type: 'Type d\'utilisateur non reconnu : {{type}}',
        contact_support_resolve: 'Email : {{email}} - Contactez le support pour résoudre ce problème'
      },
      dashboard: {
        title: 'Tableau de bord',
        welcome: 'Bienvenue',
        overview: 'Vue d\'ensemble',
        statistics: 'Statistiques',
        recent_activity: 'Activité récente',
        quick_actions: 'Actions rapides',
        notifications: 'Notifications',
        settings: 'Paramètres',
        logout: 'Déconnexion',
        your_quotas: 'Vos Quotas',
        exhibitor_quotas: 'Vos Quotas Exposant',
        visit_activity_7days: 'Activité de Visite (7 derniers jours)',
        appointment_status: 'Statut des Rendez-vous',
        interest_areas: 'Centres d\'Intérêt',
        visitor_engagement_7days: 'Engagement Visiteurs (7 derniers jours)',
        brand_exposure_7days: 'Exposition de Marque (7 derniers jours)',
        engagement_channels: 'Canaux d\'Engagement',
        login_to_see_stats: 'Connectez-vous pour voir vos statistiques.',
        minisite_views: 'Vues du mini-site',
        appointments: 'Rendez-vous',
        products: 'Produits',
        profile_views: 'Vues de profil'
      },
      admin: {
        title: 'Administration',
        dashboard_title: 'Admin Dashboard',
        welcome: 'Bienvenue, {{name}}',
        system_operational: 'Système Opérationnel',
        system_uptime: 'Uptime Système',
        api_calls_per_day: 'Appels API/jour',
        storage_used: 'Stockage Utilisé',
        required_actions: 'Actions Requises',
        items_need_attention: '{{count}} éléments nécessitent votre attention',
        registration_requests: 'Demandes d\'inscription',
        click_to_process: 'Cliquer pour traiter',
        payment_validation: 'Validation Paiements',
        manage_proofs: 'Gérer les preuves',
        exhibitors: 'Exposants',
        list_and_subscriptions: 'Liste & Abonnements',
        partners: 'Partenaires',
        list_and_packs: 'Liste & Packs',
        vip_visitors_management: 'Gestion Visiteurs VIP',
        view_list: 'Consulter la liste',
        content_to_moderate: 'Contenus à modérer',
        active_contracts: 'Contrats actifs',
        active_contracts_count: '{{count}} contrats actifs',
        platform_statistics: 'Statistiques Plateforme',
        total_users: 'Utilisateurs Total',
        active_users: 'Utilisateurs actifs',
        active_users_count: '{{count}} actifs',
        active_exhibitors: 'Exposants Actifs',
        online_count: '{{count}} en ligne',
        official_partners: 'Partenaires Officiels',
        visitors: 'Visiteurs',
        analysis_trends: 'Analyse & Tendances',
        realtime_data: 'Données en temps réel',
        user_growth_6months: 'Croissance des Utilisateurs (6 derniers mois)',
        user_distribution: 'Distribution des Utilisateurs',
        platform_activity_week: 'Activité Plateforme (Cette semaine)',
        weekly_traffic: 'Trafic Hebdomadaire',
        visits: 'Visites',
        page_views: 'Pages vues',
        quick_actions_nav: 'Actions Rapides & Navigation',
        participants_management: 'Gestion Participants',
        create_exhibitor: 'Créer un exposant',
        manage_exhibitors: 'Gérer les exposants',
        create_partner: 'Créer un partenaire',
        manage_partners: 'Gérer les partenaires',
        publication_control_title: '🔥 CONTRÔLE PUBLICATION - MODE VALIDATION CLIENT',
        publication_control_desc: '⚠️ Activer/Désactiver la visibilité GLOBALE',
        total_control: 'CONTRÔLE TOTAL',
        content_management: 'Gestion Contenu',
        create_event: 'Créer un événement',
        manage_events: 'Gérer les événements',
        create_article: 'Créer un article',
        manage_articles: 'Gérer les articles',
        media_management: 'Gestion Médias',
        manage_media: 'Gérer les médias',
        approve_media: 'Valider les médias',
        synchronization: 'Synchronisation',
        synchronizing: 'Synchronisation...',
        sync_articles: 'Sync articles',
        system_health: 'Santé Système',
        api_calls_24h: 'Appels API (24h)',
        avg_response_time: 'Temps réponse moyen',
        recent_system_activity: 'Activité Système Récente',
        registered_visitors: 'Visiteurs Inscrits',
        conferences_workshops: 'Conférences & Ateliers',
        vs_target: '{{percent}} vs objectif',
        detailed_metrics_performance: 'Métriques & Performance Détaillées',
        users: 'Utilisateurs',
        moderation: 'Modération',
        analytics: 'Analyses',
        reports: 'Rapports',
        settings: 'Paramètres',
        logs: 'Journaux',
        payments: 'Paiements',
        content: 'Contenus',
        revenue: 'Revenus',
        growth: 'Croissance'
      },
      marketing: {
        title: 'Content Strategy Hub',
        subtitle: 'Gérez l\'expérience narrative de SIPORT 2026. Publiez des contenus impactants et analysez l\'engagement.',
        badge: 'CENTRE DE CONTRÔLE MARKETING',
        btn_new_content: 'Nouveau Contenu',
        tabs: {
          media_library: 'Médiathèque',
          articles_news: 'Articles & News',
          explore: 'Explorer'
        },
        stats: {
          total_media: 'Total Médias',
          webinars: 'Webinaires',
          podcasts: 'Podcasts',
          capsules: 'Capsules',
          online: 'En Ligne',
          drafts: 'Brouillons',
          total: 'Total'
        },
        filters: {
          filter_by: 'Filtrer par :',
          status: 'Statut :',
          all: 'Tous',
          webinars: 'Webinaires',
          podcasts: 'Podcasts',
          capsules: 'Capsules',
          published: 'Publiés',
          drafts: 'Brouillons'
        },
        media: {
          add_media: 'Ajouter un média',
          no_media_found: 'Aucun média trouvé',
          no_media_desc: 'Ajoutez des photos, vidéos ou podcasts pour commencer',
          published: '✅ Publié',
          draft: '📝 Brouillon',
          publish: 'Publier',
          unpublish: 'Dépublier',
          copy: 'Copier',
          copied: 'Shortcode copié !',
          deleted: '🗑️ Média supprimé',
          added: '✅ Média ajouté',
          error_update: 'Erreur de mise à jour',
          error_delete: 'Erreur de suppression',
          title: 'Titre',
          description: 'Description',
          type: 'Type de média',
          video_url: 'URL Vidéo / Audio',
          shortcode_copied: '📋 Shortcode copié !'
        },
        articles: {
          title: 'Gestion des Articles',
          subtitle: 'Créez et gérez les articles pour siportevent.com',
          create_new: 'Créer un Nouvel Article',
          published_count: 'Publiés',
          drafts_count: 'Brouillons',
          shortcodes_info: 'Utilisation des shortcodes',
          shortcodes_desc: 'Copiez le shortcode d\'un article et collez-le dans n\'importe quelle page de siportevent.com. L\'article s\'affichera automatiquement avec sa mise en forme.',
          example: 'Exemple :',
          no_articles: 'Aucun article pour le moment',
          author: 'Auteur',
          category: 'Catégorie',
          edit: 'Éditer',
          publish: 'Publier',
          unpublish: 'Dépublier',
          delete: 'Supprimer',
          published_badge: '✅ Publié',
          draft_badge: '📝 Brouillon'
        }
      },
      exhibitor: {
        title: 'Espace Exposant',
        dashboard: 'Tableau de bord',
        products: 'Mes produits',
        appointments: 'Rendez-vous',
        minisite: 'Mon mini-site',
        analytics: 'Mes statistiques',
        leads: 'Mes leads',
        messages: 'Messages',
        calendar: 'Calendrier',
        profile: 'Mon profil',
        subscription: 'Mon abonnement',
        my_booth: 'Mon Stand',
        booth_location: 'vous êtes à votre stand',
        stats: {
          mini_site_views: 'Vues Mini-Site',
          appointments: 'Demandes de RDV',
          downloads: 'Téléchargements',
          messages: 'Messages'
        },
        quick_actions: {
          create_minisite_ai: 'Créer Mini-Site avec IA',
          create_minisite_ai_desc: 'Générez automatiquement votre mini-site depuis votre site web',
          networking_ai: 'Réseautage IA',
          networking_ai_desc: 'Découvrez des connexions pertinentes avec l\'IA',
          edit_minisite: 'Modifier mon Mini-Site',
          edit_minisite_desc: 'Personnalisez votre présence digitale',
          profile: 'Mon Profil Exposant',
          profile_desc: 'Mettez à jour vos informations',
          qr_code: 'QR Code Stand',
          qr_code_desc: 'Générez votre QR code personnalisé'
        },
        header: {
          published_tooltip_hide: 'Cliquez pour masquer votre profil',
          published_tooltip_show: 'Cliquez pour publier votre profil',
          changing: '⏳ Changement...',
          published_status: '✓ PUBLIÉ - Cliquez pour masquer',
          hidden_status: '🔒 MASQUÉ - Cliquez pour publier',
          virtual_badge: 'Mon Badge Virtuel',
          create_edit_minisite: 'Créer / Modifier mon mini-site exposant'
        },
        modals: {
          views_title: 'Détails des Vues Mini-Site',
          views_chart_title: '📊 Statistiques des Vues',
          views_text: 'Votre mini-site a été consulté {{count}} fois.',
          views_footer: 'Consultez les analytics détaillées dans la section Mini-Site.',
          appointments_title: 'Demandes de Rendez-vous',
          appointments_chart_title: '📅 Rendez-vous',
          appointments_text: 'Vous avez {{count}} rendez-vous.',
          appointments_action: 'Voir tous les rendez-vous',
          downloads_title: 'Téléchargements de Documents',
          downloads_chart_title: '📥 Documents Téléchargés',
          downloads_text: '{{count}} téléchargements de vos documents.',
          messages_title: 'Messages et Communications',
          messages_chart_title: '💬 Messages',
          messages_text: 'Vous avez {{count}} messages non lus.',
          messages_action: 'Ouvrir le chat'
        },
        activity: {
          view_all: 'Historique Complet des Activités',
          none: 'Aucune activité récente trouvée.'
        },
        status: {
          confirmed: 'Confirmés',
          pending: 'En attente',
          completed: 'Terminés'
        }
      },
      visitor: {
        title: 'Espace Visiteur',
        dashboard: 'Tableau de bord',
        exhibitors: 'Exposants',
        events: 'Événements',
        appointments: 'Mes rendez-vous',
        favorites: 'Mes favoris',
        networking: 'Réseautage',
        badge: 'Mon badge',
        subscription: 'Abonnement Privilège',
        level: 'Niveau',
        upgrade: 'Passer Privilège',
        my_appointments: 'Mes rendez-vous',
        my_favorites: 'Mes favoris',
        my_tickets: 'Mes billets',
        upgrade_required: 'Mise à niveau requise',
        schedule_appointment: 'Planifier un rendez-vous',
        appointment_confirmed: 'Rendez-vous confirmé',
        appointment_declined: 'Rendez-vous refusé',
        no_appointments: 'Aucun rendez-vous',
        upcoming_events: 'Événements à venir',
        registered_events: 'Événements inscrits',
        quota_remaining: 'RDV Restants',
        connections: 'Connexions',
        welcome_message: 'Bienvenue {{name}}, niveau {{level}}',
        connected_status: 'Connecté',
        unauthorized_access: 'Accès non autorisé',
        please_login: 'Veuillez vous connecter pour accéder à votre espace visiteur',
        exhibitors_visited: 'Exposants Visités',
        bookmarks: 'Favoris',
        messages_sent: 'Messages',
        confirmed: 'Confirmés',
        pending: 'En attente',
        refused: 'Refusés',
        interest_areas: 'Centres d\'intérêt',
        visit_activity: 'Activité de visite',
        appointment_status: 'Statut des rendez-vous',
        visitor_space: 'Espace Visiteur',
        my_profile: 'Mon profil',
        my_events: 'Mes événements',
        // Nouvelles clés manquantes
        visitor_area: 'Espace Visiteur',
        my_virtual_badge: 'Mon Badge Virtuel',
        connected: 'Connecté',
        b2b_appointments: 'Rendez-vous B2B',
        // VIP Benefits Section
        vip_benefits_title: 'Avantages VIP',
        vip_benefits_subtitle: 'Profitez d\'avantages exclusifs avec votre statut VIP',
        vip_appointments: 'RDV Illimités',
        vip_appointments_desc: 'Planifiez autant de rendez-vous B2B que vous le souhaitez',
        vip_messaging: 'Messagerie Prioritaire',
        vip_messaging_desc: 'Contactez directement les exposants et partenaires',
        vip_badge: 'Badge VIP',
        vip_badge_desc: 'Badge distinctif avec accès à toutes les zones',
        vip_ai_matching: 'Matching IA',
        vip_ai_matching_desc: 'Recommandations personnalisées par intelligence artificielle',
        vip_webinars: 'Webinaires Exclusifs',
        vip_webinars_desc: 'Accès aux contenus premium et sessions privées',
        vip_support_priority: 'Support Prioritaire',
        vip_support_desc: 'Assistance dédiée VIP',
        vip_news_priority: 'Nouveautés Prioritaires',
        vip_news_desc: 'Accès avant-première',
        // AI Networking Section
        ai_networking: 'Réseautage IA',
        ai_networking_desc: 'Découvrez des opportunités de networking personnalisées grâce à notre intelligence artificielle',
        explore_network: 'Explorer le réseau',
        configure_matching: 'Configurer le matching',
        // Appointments Section
        schedule_appointment_desc: 'Organisez vos rendez-vous B2B avec les exposants et partenaires',
        program_appointment: 'Programmer un RDV',
        appointments_remaining: 'RDV Restants',
        quota_reached: 'Quota atteint pour le niveau {{level}}. Passez VIP pour des RDV illimités !',
        // Activity Section
        your_activity: 'Votre Activité',
        your_activity_desc: 'Suivez vos interactions et statistiques',
        live: 'EN DIRECT',
        visits: 'Visites',
        interactions: 'Interactions',
        currently: 'Actuellement',
        previous_period: 'Période précédente',
        confirmed_appointments: 'RDV Confirmés',
        connections_established: 'Connexions Établies',
        // Messaging Section
        messaging: 'Messagerie',
        messaging_desc: 'Échangez avec les exposants et partenaires',
        open_messaging: 'Ouvrir la Messagerie',
        // Networking Hub Section
        personal: 'Votre Hub',
        networking_hub: 'Réseautage Personnalisé',
        networking_hub_desc: 'Développez votre réseau professionnel',
        my_schedule: 'Mon Programme',
        // Events Section
        no_registered_events: 'Aucun événement inscrit',
        appointments_booked: 'RDV Programmés',
        browse_program: 'Parcourir le programme',
        view_full_program: 'Voir le Programme Complet',
        // Premium Feature Section
        premium_feature: 'Fonctionnalité Premium',
        b2b_reserved_message: 'Les rendez-vous B2B sont réservés aux visiteurs VIP. Passez VIP pour débloquer cette fonctionnalité et bien plus !',
        upgrade_level: 'Passer VIP Maintenant',
        loading_appointments: 'Chargement des rendez-vous...',
        // Invitations Section
        new_invitations: 'Nouvelles Invitations',
        action_required: 'Action Requise',
        no_message: 'Pas de message',
        appointment_with: 'rendez-vous avec'
      },
      partner: {
        title: 'Espace Partenaire',
        activation_required: 'Activation Requise',
        payment_validation_needed: 'Votre compte est en attente de validation de paiement.',
        finalize_payment: 'Finaliser le Paiement',
        payment_validation_required: 'Validation Requise',
        payment_activation_message: 'Pour activer votre compte partenaire et accéder à toutes les fonctionnalités, veuillez procéder au règlement de votre adhésion.',
        make_payment: 'Procéder au Paiement',
        access_denied: 'Accès Réservé',
        reserved_partners: 'Cet espace est réservé aux partenaires. Veuillez vous connecter avec un compte partenaire.',
        dashboard_live: 'Dashboard Live',
        virtual_badge: 'Mon Badge Virtuel',
        roi_performance: 'Performance ROI',
        hero_title: 'Business Networking Hub',
        hero_subtitle: 'Gérez vos opportunités d\'affaires et maximisez votre impact lors de l\'événement SIPORT 2026.',
        tabs: {
          overview: 'Vue d\'ensemble',
          profile: 'Mon Stand & Profil',
          networking: 'Rendez-vous',
          analytics: 'Analytics ROI'
        },
        stats: {
          profile_views: 'Vues Profil',
          connections: 'Connexions',
          appointments: 'Rendez-vous',
          messages: 'Messages'
        },
        quotas: {
          title: 'Quotas & Avantages',
          description: 'Gérez votre consommation de ressources.',
          available: 'Disponible',
          appointments: 'Rendez-vous B2B',
          team_members: 'Membres Équipe',
          media_files: 'Fichiers Media'
        },
        ai_generation: 'Génération IA',
        ai_description: 'Laissez notre IA analyser votre site web et remplir automatiquement votre profil partenaire avec vos logos, descriptions et services.',
        ai_button: 'Auto-Fill avec SIPORT AI',
        manual_management: 'Gestion Manuelle',
        manual_description: 'Modifiez manuellement tous les détails de votre profil partenaire.',
        manual_button: 'Éditer le Profil',
        edit_basic_info: 'Modifier les informations de base',
        media_catalog: 'Catalogue Média & Documents',
        recent_activity: 'Activités Récentes',
        appointments_management: 'Gestion des Rendez-vous',
        appointments_description: 'Gérez vos demandes de rendez-vous et votre disponibilité.',
        confirmed_appointments: 'Rendez-vous Confirmés',
        pending: 'En Attente',
        pending_requests: '{{count}} demandes en attente',
        no_pending_requests: 'Aucune demande en attente',
        pending_requests_appear_here: 'Les nouvelles demandes apparaîtront ici',
        accept: 'Accepter',
        reject: 'Refuser',
        share_scheduling_link: 'Partager mon lien RDV',
        share_calendar_description: 'Partagez votre lien unique pour permettre aux visiteurs de réserver des créneaux directement.',
        copy_virtual_booth_link: 'Copier mon lien de Stand Virtuel',
        copy_link_success: 'Lien copié !',
        no_message: 'Pas de message',
        analytics_titles: {
          brand_visibility: 'Visibilité de la Marque (7 jours)',
          engagement_channels: 'Canaux d\'Engagement',
          metrics_distribution: 'Répartition des Métriques'
        },
        global_roi_performance: 'Performance ROI Globale',
        export_pdf_report: 'Exporter Rapport PDF',
        autofill_profile_ai: 'Remplissage Automatique IA',
        autofill_description: 'Utilisez notre IA pour extraire les informations de votre site web.',
        edit_profile_manually: 'Édition Manuelle du Profil',
        update_company_info: 'Mettez à jour les informations de votre entreprise.',
        // Added from duplicate block
        notFound: 'Partenaire introuvable',
        notFoundDesc: "Nous ne trouvons pas le partenaire que vous recherchez.",
        notFoundGeneric: 'Aucun partenaire trouvé',
        backToList: 'Retour à la liste',
        discoverSiports: 'Découvrir SIPORTS',
        areYouPartner: 'Êtes-vous un partenaire ?',
        completeProfile: 'Complétez votre profil pour plus de visibilité',
        back_to_dashboard: 'Retour au tableau de bord',
        priority: 'Prioritaire',
        details: 'Détails'
      },
      media: {
        title: 'Médiathèque',
        menu_title: 'Média',
        webinars: 'Webinaires',
        webinars_desc: 'Webinaires sponsorisés en replay',
        podcasts: 'Podcasts',
        podcasts_desc: 'SIPORT Talks - Épisodes audio',
        videos: 'Vidéos',
        live: 'En direct',
        capsules: 'Capsules Inside',
        capsules_desc: 'Capsules vidéo Inside SIPORT',
        live_studio: 'Live Studio',
        live_studio_desc: 'Meet The Leaders - Interviews live',
        best_moments: 'Best Moments',
        best_moments_desc: 'Meilleurs moments du salon',
        testimonials: 'Témoignages',
        testimonials_desc: 'Témoignages vidéo',
        library: 'Bibliothèque Média',
        library_desc: 'Tous les contenus médias',
        categories: 'Catégories',
        trending: 'Tendances',
        latest: 'Nouveautés',
        watch: 'Regarder',
        listen: 'Écouter',
        share: 'Partager',
        like: 'J\'aime',
        views: 'vues',
        duration: 'Durée'
      },
      notifications: {
        title: 'Notifications',
        mark_all_read: 'Tout marquer comme lu',
        no_notifications: 'Aucune notification',
        new: 'Nouveau',
        unread: 'Non lu',
        settings: 'Paramètres de notification',
        email_notifications: 'Notifications par email',
        push_notifications: 'Notifications push',
        sms_notifications: 'Notifications SMS',
        preferences: 'Préférences'
      },
      security: {
        title: 'Sécurité',
        two_factor: 'Authentification à deux facteurs',
        enable_2fa: 'Activer 2FA',
        disable_2fa: 'Désactiver 2FA',
        totp: 'Application d\'authentification',
        sms: 'SMS',
        email: 'Email',
        backup_codes: 'Codes de secours',
        password: 'Mot de passe',
        change_password: 'Changer le mot de passe',
        change_password_desc: 'Modifiez votre mot de passe temporaire pour sécuriser votre compte.',
        current_password: 'Mot de passe actuel',
        new_password: 'Nouveau mot de passe',
        confirm_password: 'Confirmer le nouveau mot de passe',
        new_password_placeholder: 'Minimum 8 caractères',
        confirm_password_placeholder: 'Retapez le nouveau mot de passe',
        password_requirements: 'Minimum 8 caractères. Utilisez des lettres, chiffres et symboles.',
        change_password_btn: 'Mettre à jour le mot de passe',
        password_changed: 'Mot de passe modifié avec succès !',
        passwords_mismatch: 'Les mots de passe ne correspondent pas.',
        password_too_short: 'Le mot de passe doit contenir au moins 8 caractères.',
        current_password_wrong: 'Le mot de passe actuel est incorrect.',
        fields_required: 'Tous les champs sont obligatoires.',
        sessions: 'Sessions actives',
        api_keys: 'Clés API',
        audit_logs: 'Journaux d\'audit'
      },
      analytics: {
        title: 'Analyses',
        overview: 'Vue d\'ensemble',
        visitors: 'Visiteurs',
        pageviews: 'Pages vues',
        conversions: 'Conversions',
        revenue: 'Revenus',
        export: 'Exporter',
        period: 'Période',
        today: 'Aujourd\'hui',
        week: 'Cette semaine',
        month: 'Ce mois',
        year: 'Cette année',
        custom: 'Personnalisé'
      },
      payments: {
        title: 'Paiements',
        methods: 'Méthodes de paiement',
        history: 'Historique',
        invoices: 'Factures',
        refunds: 'Remboursements',
        pending: 'En attente',
        completed: 'Complété',
        failed: 'Échoué',
        amount: 'Montant',
        date: 'Date',
        status: 'Statut',
        download_invoice: 'Télécharger la facture'
      },
      partner_legacy: {
        notFound: 'Partenaire introuvable',
        notFoundDesc: "Nous ne trouvons pas le partenaire que vous recherchez.",
        notFoundGeneric: 'Aucun partenaire trouvé',
        backToList: 'Retour à la liste',
        discoverSiports: 'Découvrir SIPORTS',
        areYouPartner: 'Êtes-vous un partenaire ?',
        completeProfile: 'Complétez votre profil pour plus de visibilité',
        back_to_dashboard: 'Retour au tableau de bord',
        priority: 'Prioritaire',
        details: 'Détails',
        activation_required: 'Activation Requise',
        payment_validation_needed: 'Votre compte est créé mais nécessite une validation de paiement pour activer l\'accès au tableau de bord.',
        finalize_payment: 'Finaliser le Paiement',
        access_denied: 'Accès Non Autorisé',
        reserved_partners: 'Ce tableau de bord est réservé aux partenaires SIPORTS 2026.',
        payment_validation_required: 'Validation de Paiement Requise',
        payment_activation_message: 'Pour activer toutes les fonctionnalités de votre compte partenaire "Premium", veuillez finaliser votre règlement. Accès actuellement limité à la soumission de preuve.',
        make_payment: 'Effectuer le Paiement',
        dashboard_live: 'Dashboard Live',
        ai_generation: 'Génération IA Intelligent',
        appointments_management: 'Gestion des Rendez-vous',
        appointments_description: 'Planifiez et gérez vos rencontres d\'affaires B2B.',
        pending: 'En attente',
        pending_requests: 'Demandes à traiter ({{count}})',
        no_pending_requests: 'Aucune demande en attente',
        pending_requests_appear_here: 'Les nouvelles demandes apparaîtront ici',
        share_calendar_description: 'Partagez votre agenda directement avec vos clients et prospects pour simplifier la prise de contact.',
        global_roi_performance: 'Performance ROI Globale',
        export_pdf_report: 'Exporter le Rapport PDF',
        autofill_profile_ai: 'Auto-Fill Profile with AI',
        autofill_description: 'Automatically extract information from your website',
        edit_profile_manually: 'Edit Profile Manually',
        update_company_info: 'Update your company information',
        status: {
          upcoming: 'À venir',
          draft: 'Brouillon'
        },
        events: {
          title: 'Événements Sponsorisés',
          subtitle: 'Gérez vos événements partenaires et suivez leur impact',
          program: 'Programme Événements Partenaires',
          available: 'Événements disponibles',
          loading: 'Chargement des événements...',
          none: 'Aucun événement disponible pour le moment.',
          registered: 'inscrits',
          capacity: 'Capacité'
        },
        leads: {
          title: 'Leads & Prospects',
          subtitle: 'Gérez vos leads qualifiés et suivez leur progression dans le pipeline commercial',
          premium_program: 'Programme Leads Privilège',
          conversion_rate: '12% Taux de Conversion',
          generated: 'Leads générés',
          qualified: 'Leads qualifiés',
          conversion: 'Taux de conversion',
          estimated_value: 'Valeur estimée',
          recent: 'Leads Récents',
          exhibitor: 'Exposant',
          visitor: 'Visiteur',
          other: 'Autre',
          connected: 'Connecté',
          pending: 'En attente',
          rejected: 'Rejeté',
          active_followup: 'Suivi actif',
          awaiting_response: 'En attente de réponse',
          sources: {
            events: 'Événements SIPORTS',
            networking: 'Réseautage Partenaires',
            referrals: 'Références Clients',
            marketing: 'Campagnes Marketing'
          },
          funnel: {
            generated: 'Leads Générés',
            qualified: 'Qualifiés',
            proposal: 'Proposition',
            negotiation: 'Négociation',
            conversion: 'Conversion'
          },
          tips: {
            title: 'Conseils de Gestion des Leads',
            qualification: 'Qualification Rapide',
            qualification_desc: 'Contactez les leads chauds dans les 24h pour maximiser vos chances de conversion',
            followup: 'Suivi Régulier',
            followup_desc: "Planifiez des points de suivi hebdomadaires pour maintenir l'engagement",
            personalization: 'Personnalisation',
            personalization_desc: 'Adaptez vos propositions aux besoins spécifiques de chaque prospect',
            measure: 'Mesure des Résultats',
            measure_desc: 'Analysez régulièrement vos taux de conversion pour optimiser votre approche'
          }
        },
        activity: {
          title: 'Activité Partenaire',
          subtitle: 'Suivez toutes vos interactions et engagements SIPORTS',
          full_history: 'Historique Complet des Activités',
          realtime: 'Temps Réel',
          history: 'Historique des Activités',
          no_activity: 'Aucune activité trouvée',
          try_filters: 'Essayez de modifier vos filtres de recherche',
          just_now: "À l'instant",
          hours_ago: 'Il y a {{count}}h',
          days_ago: 'Il y a {{count}}j',
          stats: {
            total: 'Activités totales',
            today: "Aujourd'hui",
            this_week: 'Cette semaine'
          },
          filter: {
            all: 'Toutes les activités',
            networking: 'Réseautage',
            communication: 'Communication',
            events: 'Événements',
            sponsorship: 'Sponsoring',
            engagement: 'Engagement',
            content: 'Contenu',
            meetings: 'Rendez-vous',
            system: 'Système'
          },
          type: {
            connection: 'Connexion',
            message: 'Message',
            event: 'Événement',
            sponsorship: 'Sponsoring',
            consultation: 'Consultation',
            content: 'Contenu',
            alert: 'Alerte',
            meeting: 'Rendez-vous'
          },
          connection_established: 'Nouvelle connexion établie',
          connected_with: 'Vous êtes maintenant connecté avec Port Solutions Inc.',
          new_message: 'Nouveau message reçu',
          message_from: 'TechMarine Solutions vous a envoyé un message',
          event_participation: 'Participation à un événement',
          participated_in: 'Vous avez participé à la conférence "Digital Transformation in Ports"',
          sponsoring_activated: 'Sponsoring activé',
          logo_displayed: "Votre logo est maintenant affiché sur la page d'accueil",
          profile_viewed: 'Profil consulté',
          views_today: "Votre profil a été consulté 15 fois aujourd'hui",
          content_shared: 'Contenu partagé',
          article_shared: 'Votre article "Innovation in Maritime Technology" a été partagé',
          system_alert: 'Alerte système',
          metrics_update: 'Mise à jour de vos métriques de performance disponible',
          meeting_scheduled: 'Rendez-vous programmé',
          meeting_confirmed: 'RDV confirmé avec LogiFlow Systems demain à 14h'
        },
        calendar: {
          title: 'Calendrier des Rendez-vous',
          create_slot: 'Nouveau Créneau',
          slot_date_restriction: 'Les créneaux doivent être créés entre le 1er et le 3 avril 2026',
          date_outside_salon: 'La date doit être comprise entre le 1er et le 3 avril 2026'
        }
      },
      contact: {
        title: 'Contactez-nous',
        subtitle: 'Notre équipe est à votre écoute',
        form_title: 'Formulaire de contact',
        first_name: 'Prénom',
        last_name: 'Nom',
        email: 'Email',
        company: 'Entreprise',
        subject: 'Sujet',
        message: 'Message',
        send: 'Envoyer',
        sending: 'Envoi en cours...',
        required_fields: 'Veuillez remplir tous les champs obligatoires',
        invalid_email: 'Veuillez entrer une adresse email valide',
        min_message_length: 'Le message doit contenir au moins 10 caractères',
        success_title: 'Message envoyé !',
        success_message: 'Nous vous répondrons dans les plus brefs délais',
        error_message: 'Une erreur est survenue. Veuillez réessayer plus tard.',
        subjects: {
          general: 'Question générale',
          exhibitor: 'Information exposant',
          visitor: 'Information visiteur',
          technical: 'Support technique',
          partnership: 'Partenariat'
        },
        info: {
          email: 'contact@siportevent.com',
          phone: '+213 XXX XXX XXX',
          address: 'Alger, Algérie'
        }
      },
      venue: {
        title: 'Lieu de l\'événement',
        subtitle: 'Découvrez où se déroulera SIPORTS 2026',
        location: 'Lieu',
        dates: 'Dates',
        opening_hours: 'Horaires d\'ouverture',
        access: 'Accès',
        parking: 'Parking',
        public_transport: 'Transports en commun',
        directions: 'Itinéraire',
        map: 'Plan du site',
        facilities: 'Infrastructures',
        wifi: 'WiFi gratuit',
        restaurants: 'Restaurants',
        restrooms: 'Toilettes'
      },
      accommodation: {
        badge: 'Hébergement Partenaires',
        title: 'Hébergement à El Jadida',
        subtitle: 'Profitez de tarifs préférentiels dans nos hôtels partenaires',
        hotels_partners: 'Hôtels partenaires',
        vip_discount: 'Réduction VIP',
        april_dates: 'Avril 2026',
        vip_advantage_title: '🌟 Avantage Visiteurs VIP',
        vip_advantage_desc: 'En tant que visiteur VIP, bénéficiez de tarifs préférentiels exclusifs sur tous nos hôtels partenaires',
        vip_benefit_1: 'Jusqu\'à -20% sur tous les hôtels',
        vip_benefit_2: 'Réservation prioritaire garantie',
        vip_benefit_3: 'Surclassement gratuit selon disponibilité',
        featured_partner: '⭐ Partenaire Premium',
        standard_rate: 'Tarif Standard',
        vip_rate: 'Tarif VIP',
        per_night: 'par nuit',
        view_details: 'Voir les détails',
        amenity_wifi: 'WiFi Gratuit',
        amenity_parking: 'Parking',
        amenity_pool: 'Piscine',
        amenity_spa: 'Spa',
        amenity_restaurant: 'Restaurant',
        amenity_gym: 'Salle de sport',
        amenity_casino: 'Casino',
        amenity_beach: 'Accès plage',
        amenity_golf: 'Golf',
        amenity_bar: 'Bar',
        amenity_terrace: 'Terrasse',
        how_to_book: 'Comment réserver ?',
        step1_title: 'Choisissez votre hôtel',
        step1_desc: 'Sélectionnez l\'hôtel qui correspond à vos besoins',
        step2_title: 'Contactez l\'hôtel',
        step2_desc: 'Appelez directement ou envoyez un email',
        step3_title: 'Mentionnez SIPORTS',
        step3_desc: 'Indiquez le code "SIPORTS2026" pour le tarif préférentiel',
        step4_title: 'Confirmez votre réservation',
        step4_desc: 'Recevez votre confirmation par email',
        need_help: 'Besoin d\'aide pour réserver ?',
        contact_desc: 'Notre équipe est disponible pour vous assister'
      },
      badge: {
        title: 'Mon Badge',
        subtitle: 'Badge d\'accès événement',
        qr_code: 'Code QR',
        download: 'Télécharger',
        print: 'Imprimer',
        scan_instructions: 'Présentez ce code QR à l\'entrée',
        visitor_info: 'Informations visiteur',
        level_info: 'Niveau',
        valid_dates: 'Valide du 1er au 3 avril 2026',
        access_granted: 'Accès autorisé',
        upgrade_to_premium: 'Passer Privilège pour plus d\'avantages',
        loading_badge: 'Chargement de votre badge...',
        access_badge: 'Badge d\'Accès',
        unknown_level: 'Niveau inconnu',
        automatic_rotation: 'Rotation automatique',
        secure_qr_jwt: 'QR Code Sécurisé JWT',
        authorized_zones: 'Zones Autorisées',
        total_access: 'Accès Total',
        regenerate_qr: 'Régénérer le QR Code',
        max_security: 'Sécurité Maximale',
        security_info: 'Votre QR code se régénère automatiquement toutes les 30 secondes pour une sécurité optimale. Ne partagez jamais votre badge.',
        my_access_badge: 'Mon Badge d\'Accès',
        download_print_info: 'Téléchargez ou imprimez votre badge pour accéder au salon.',
        generate_badge_info: 'Générez votre badge personnalisé avec QR code pour accéder au salon.',
        generating: 'Génération...',
        generate_my_badge: 'Générer mon badge',
        download_png: 'Télécharger PNG',
        regenerating: 'Régénération...',
        regenerate: 'Régénérer',
        badge_generated_success: 'Badge généré avec succès !',
        badge_downloaded: 'Badge téléchargé !',
        download_error: 'Erreur lors du téléchargement. Veuillez faire une capture d\'écran du badge.',
        error_loading: 'Erreur lors du chargement du badge',
        error_generating: 'Erreur lors de la génération du badge',
        login_required: 'Connexion requise',
        must_login_badge: 'Vous devez être connecté pour voir votre badge.',
        stand_number: 'Stand N°',
        valid_from: 'Valide du',
        usage_instructions: 'Instructions d\'utilisation',
        instruction_1: 'Téléchargez',
        instruction_1_desc: 'votre badge ou imprimez-le.',
        instruction_2: 'Conservez',
        instruction_2_desc: 'le badge sur votre téléphone.',
        instruction_3: 'Présentez',
        instruction_3_desc: 'le QR code à l\'entrée.',
        instruction_4: 'Portez',
        instruction_4_desc: 'votre badge visiblement.',
        vip_advantages: 'Avantages VIP',
        vip_advantage_1: 'Accès illimité à toutes les zones',
        vip_advantage_2: 'Rendez-vous B2B illimités',
        vip_advantage_3: 'Accès aux événements exclusifs',
        statistics: 'Statistiques',
        scans_done: 'Scans effectués',
        status: 'Statut',
        active: 'Actif',
        last_scan: 'Dernier scan'
      },
      profile: {
        not_found: 'Profil introuvable',
        edit_profile: 'Modifier le profil',
        change_photo: 'Changer la photo de profil',
        about_placeholder: 'Parlez-nous de vous et de votre expertise...',
        first_name: 'Prénom',
        last_name: 'Nom',
        position: 'Poste',
        country: 'Pays',
        company_name: 'Nom de votre entreprise',
        company_placeholder: 'Ex: Consultant indépendant',
        sector_placeholder: 'Ex: Consulting maritime',
        click_to_edit: 'Cliquer pour modifier'
      },
      products: {
        min_one_image: 'Veuillez télécharger au moins une image pour ce produit',
        error_saving_images: 'Erreur lors de la sauvegarde des images',
        product_images: 'Images du produit',
        upload_images_desc: 'Téléchargez des photos de votre produit. La première image sera utilisée comme image principale. Vous pouvez réorganiser les images par glisser-déposer.'
      },
      siteBuilder: {
        search_template: 'Rechercher un template...',
        search_image: 'Rechercher une image...',
        main_title: 'Titre principal',
        subtitle: 'Sous-titre',
        button_text: 'Texte bouton',
        product_name: 'Nom produit',
        price: 'Prix',
        author: 'Auteur',
        section_title: 'Titre',
        description: 'Description...',
        video_url: 'URL vidéo YouTube/Vimeo',
        custom_html: 'Code HTML personnalisé',
        seo_title_placeholder: 'ex: Votre Entreprise - Solutions Innovantes',
        seo_description_placeholder: 'Description concise et attractive de votre page...',
        seo_slug_placeholder: 'votre-page',
        add_keyword: 'Ajouter un mot-clé...',
        og_image_placeholder: 'https://example.com/image.jpg'
      },
      minisite: {
        click_to_edit: 'Cliquer pour modifier',
        delete_section: 'Supprimer la section',
        delete_product: 'Supprimer ce produit',
        change_image: 'Cliquer pour changer l\'image',
        delete_image: 'Supprimer l\'image',
        delete_article: 'Supprimer cet article',
        section_title: 'Titre de la section',
        company_description: 'Description de votre entreprise',
        feature: 'Caractéristique',
        products_section_title: 'Titre de la section produits',
        upload_images: 'Upload d\'images et médias',
        // Wizard labels
        step_company: 'Nom de la société',
        step_logo: 'Logo',
        step_description: 'Description',
        step_documents: 'Documents (PDF, Brochure...)',
        step_products: 'Produits principaux',
        step_socials: 'Réseaux sociaux',
        // Placeholders
        placeholder_company: 'Votre société',
        placeholder_description: 'Décrivez votre activité...',
        placeholder_products: 'Listez vos produits phares...',
        placeholder_socials: 'Lien LinkedIn, Facebook...',
        placeholder_url: 'https://votresite.com',
        // Titles & Headers
        wizard_title: '🚀 Création de votre mini-site',
        auto_creation_title: '✨ Création automatique depuis votre site web',
        manual_alternative: 'Ou remplissez manuellement les informations',
        // Buttons
        auto_generate_button: '🚀 Créer automatiquement mon mini-site',
        generating_auto: 'Génération automatique en cours...',
        generate_button: 'Générer mon mini-site',
        generating: 'Génération en cours...',
        button_previous: 'Précédent',
        button_next: 'Suivant',
        // Success
        success_emoji: '🎉',
        success_title: 'Mini-site généré avec succès !',
        success_message: 'Vous pouvez maintenant le personnaliser ou le partager.',
        view_my_minisite: 'Voir mon mini-site',
        back_to_dashboard: 'Retour au dashboard',
        // Errors
        invalid_url: 'URL invalide',
        timeout_error: 'Le site {{domain}} met trop de temps à répondre. Veuillez réessayer ou utiliser le mode manuel.',
        not_accessible_error: 'Le site {{domain}} n\'est pas accessible. Vérifiez l\'URL et réessayez.',
        ai_unavailable: 'Le service de génération automatique est temporairement indisponible. Veuillez utiliser le mode manuel ou réessayer plus tard.',
        fetch_error: 'Impossible de récupérer les informations du site. {{message}}',
        unknown_error: 'Erreur inconnue',
        login_required: 'Vous devez être connecté pour créer un mini-site',
        creation_error: 'Erreur lors de la création du mini-site.',
        error_title: 'Erreur',
        // AI Info
        ai_info: '🤖 Notre IA récupérera automatiquement : nom, logo, description, produits, contacts et réseaux sociaux.',
        // Fallback
        default_company: 'Entreprise'
      },
      minisite_editor: {
        // Page titles & headers
        page_title: 'Éditeur de Mini-Site',
        page_subtitle: 'Personnalisez votre mini-site en temps réel',
        back_to_dashboard: 'Retour au dashboard',
        preview: 'Prévisualiser',
        save: 'Sauvegarder',
        saving: 'Sauvegarde...',
        // Section types
        section_hero: 'Section Hero',
        section_about: 'À propos',
        section_products: 'Produits',
        section_gallery: 'Galerie',
        section_news: 'Actualités',
        section_contact: 'Contact',
        section_products_services: 'Produits & Services',
        // Section descriptions
        desc_hero: 'Bannière d\'accueil avec titre et CTA',
        desc_about: 'Présentation de votre entreprise',
        desc_products: 'Catalogue de vos produits et services',
        desc_gallery: 'Photos et vidéos de votre entreprise',
        desc_news: 'Dernières nouvelles et annonces',
        desc_contact: 'Informations de contact et formulaire',
        // Default content
        default_your_title: 'Votre titre',
        default_your_subtitle: 'Votre sous-titre',
        default_learn_more: 'En savoir plus',
        default_about_us: 'À propos de nous',
        default_describe_company: 'Décrivez votre entreprise ici...',
        default_feature_1: 'Nouvelle fonctionnalité 1',
        default_feature_2: 'Nouvelle fonctionnalité 2',
        default_our_products: 'Nos produits',
        default_gallery_title: 'Galerie',
        default_news_title: 'Actualités',
        default_contact_us: 'Contactez-nous',
        default_your_address: 'Votre adresse',
        default_your_phone: 'Votre téléphone',
        default_your_email: 'votre@email.com',
        default_your_website: 'https://votre-site.com',
        default_your_hours: 'Vos horaires',
        default_new_product: 'Nouveau produit',
        default_product_desc: 'Description du produit',
        default_feature: 'Fonctionnalité',
        default_on_quote: 'Sur devis',
        default_new_section: 'Nouvelle section',
        // Example data
        example_company_name: 'Port Solutions Inc.',
        example_company_subtitle: 'Leading provider of integrated port management solutions',
        example_discover_solutions: 'Découvrir nos solutions',
        example_our_expertise: 'Notre expertise',
        example_expertise_desc: 'Avec plus de 20 ans d\'expérience dans le secteur portuaire, nous accompagnons les ports du monde entier dans leur transformation digitale.',
        example_innovative_solutions: 'Solutions innovantes',
        example_recognized_expertise: 'Expertise reconnue',
        example_support_24_7: 'Support 24/7',
        example_international_presence: 'Présence internationale',
        example_our_solutions: 'Nos solutions',
        example_product_1_name: 'Système IA Maritime',
        example_product_1_desc: 'Plateforme intelligente d\'optimisation des opérations portuaires avec IA prédictive',
        example_product_1_feat_1: 'Analytics prédictifs en temps réel',
        example_product_1_feat_2: 'Automatisation IA',
        example_product_1_feat_3: 'Intégration API complète',
        example_product_2_name: 'Plateforme IoT Connectée',
        example_product_2_desc: 'Solution IoT de supervision et monitoring des équipements portuaires',
        example_product_2_feat_1: 'Capteurs intelligents',
        example_product_2_feat_2: 'Maintenance prédictive',
        example_product_2_feat_3: 'Alertes instantanées',
        example_product_3_name: 'Support Premium 24/7',
        example_product_3_desc: 'Assistance technique dédiée et formation continue de vos équipes',
        example_product_3_feat_1: 'Équipe dédiée multilingue',
        example_product_3_feat_2: 'Intervention sous 2h',
        example_product_3_feat_3: 'Formation personnalisée',
        example_price_from: 'À partir de 15 000€',
        example_price_monthly: '2 500€/mois',
        example_address: '123 Port Avenue, Casablanca, Maroc',
        example_hours: 'Lun-Ven: 8h-18h',
        // Actions & buttons
        add_section: 'Ajouter une section',
        add_section_hero: 'Ajouter Section Hero',
        add_product: 'Ajouter un produit',
        remove_section: 'Supprimer la section',
        hide_section: 'Masquer la section',
        show_section: 'Afficher la section',
        click_to_edit: 'Cliquer pour modifier',
        edit_field: 'Modifier ce champ',
        save_changes: 'Sauver',
        cancel_changes: 'Annuler',
        // Sidebar
        site_settings: 'Paramètres du site',
        primary_color: 'Couleur principale',
        font_family: 'Police',
        logo_url: 'URL du logo',
        upload_logo: 'Uploader le logo',
        add_sections: 'Ajouter des sections',
        sections_list: 'Sections',
        color_picker_label: 'Sélecteur de couleur principale',
        color_hex_label: 'Code couleur principale (hex)',
        // Confirmations
        confirm_delete_section: 'Êtes-vous sûr de vouloir supprimer la section "{{title}}" ?',
        confirm_delete_product: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
        // Success messages
        section_added: '✅ SECTION AJOUTÉE — {{title}}',
        section_deleted: 'Section supprimée : "{{title}}". Ordre réorganisé.',
        section_visibility_changed: 'Visibilité modifiée : {{title}} ({{visibility}})',
        section_visible: 'Visible',
        section_hidden: 'Masquée',
        product_added: '✅ Produit ajouté.',
        product_deleted: 'Produit supprimé.',
        changes_saved: '✅ Mini-site sauvegardé avec succès !',
        // Error messages
        no_exhibitor_found: 'Aucun exposant trouvé pour cet utilisateur',
        error_loading_minisite: 'Impossible de charger le mini-site',
        error_saving_minisite: 'Erreur lors de la sauvegarde',
        must_be_exhibitor: 'Vous devez être connecté en tant qu\'exposant pour sauvegarder',
        must_be_logged_in: 'Vous devez être connecté',
        // Empty states
        no_sections_message: 'Ajoutez des sections pour commencer à créer votre mini-site',
        // Instructions
        instructions_title: '💡 Comment utiliser l\'éditeur',
        instructions_edit_title: '✏️ Modification du texte :',
        instructions_edit_1: '• Cliquez sur n\'importe quel texte pour le modifier',
        instructions_edit_2: '• Tapez votre nouveau contenu',
        instructions_edit_3: '• Cliquez "Sauver" pour confirmer',
        instructions_edit_4: '• Cliquez "Annuler" pour revenir au texte original',
        instructions_sections_title: '🎨 Gestion des sections :',
        instructions_sections_1: '• Ajoutez des sections depuis la sidebar',
        instructions_sections_2: '• Cliquez sur l\'œil pour masquer/afficher',
        instructions_sections_3: '• Utilisez la corbeille pour supprimer',
        instructions_sections_4: '• Glissez-déposez pour réorganiser',
        instructions_media_title: '🖼️ Images et médias :',
        instructions_media_1: '• Cliquez sur une image pour la changer',
        instructions_media_2: '• Formats supportés: JPG, PNG, WebP',
        instructions_media_3: '• Taille max recommandée: 2MB',
        instructions_media_4: '• Optimisation automatique'
      },
      ui: {
        search: 'Rechercher...',
        uploading: 'Upload en cours...',
        filtered_count: 'Nombre filtré',
        search_by: 'Rechercher par nom, email, entreprise ou référence...',
        click_to_change: 'Cliquer pour changer',
        view: 'Voir',
        share_article: 'Partager l\'article',
        share_event: 'Partager cet événement',
        back_to_top: 'Retour en haut',
        sync_official: 'Synchroniser avec le site officiel SIPORTS',
        contact_directly: 'Contacter directement',
        book_appointment: 'Prendre rendez-vous',
        add_remove_favorite: 'Ajouter/Retirer des favoris',
        contact_info: 'Informations de contact',
        forward_10s: 'Avancer de 10s',
        backward_10s: 'Reculer de 10s'
      },
      partner_edit: {
        basic_info: 'Informations de base',
        contact_info: 'Informations de contact',
        sectors_services: 'Secteurs & Services',
        expertise: 'Notre Expertise',
        projects: 'Projets & Réalisations',
        gallery: 'Galerie Photos',
        news: 'Actualités & Annonces',
        metrics: 'Impact & Métriques',
        timeline: 'Historique & Timeline',
        team: 'Notre Équipe',
        admin_only: 'Seul l\'administrateur peut modifier le niveau de sponsoring',
        company_example: 'Tanger Med Logistics',
        country_example: 'Maroc',
        website_placeholder: 'https://votre-site.com',
        description_example: 'Partenaire logistique premium du port de Tanger Med, offrant des services de stockage et de distribution internationaux.'
      },
      admin_media: {
        manager_title: 'Gestionnaire de médias administrateur',
        create_title_example: 'Ex: Webinaire - Innovation Portuaire 2026',
        create_description_placeholder: 'Description détaillée du contenu...',
        url_placeholder: 'https://...',
        duration_example: 'Ex: 3600',
        tags_example: 'innovation, technologie, digital',
        reject_reason: 'Expliquez pourquoi ce média est rejeté...'
      },
      social: {
        follow_facebook: 'Suivez-nous sur Facebook',
        follow_twitter: 'Suivez-nous sur Twitter',
        follow_linkedin: 'Suivez-nous sur LinkedIn',
        youtube_channel: 'Chaîne YouTube SIPORTS'
      },
      networking: {
        search_room: 'Rechercher une salle...',
        ai_reserved_premium: 'Le réseautage intelligent par IA est réservé aux membres Premium et VIP. Boostez votre expérience et découvrez des connexions stratégiques.',
        excellent_match: 'Excellent match',
        good_match: 'Bon match',
        potential_match: 'Match potentiel',
        low_match: 'Match faible'
      },
      registration: {
        name: 'Nom',
        bio: 'Bio'
      },
      forms: {
        labels: {
          firstName: 'Prénom',
          lastName: 'Nom',
          email: 'Email',
          emailAddress: 'Adresse e-mail',
          password: 'Mot de passe',
          passwordConfirm: 'Confirmer le mot de passe',
          phone: 'Téléphone',
          address: 'Adresse',
          city: 'Ville',
          country: 'Pays',
          company: 'Entreprise',
          companyName: 'Nom de l\'entreprise',
          organizationName: 'Nom de l\'organisation',
          position: 'Poste',
          positionFunction: 'Poste / Fonction',
          function: 'Fonction',
          sector: 'Secteur',
          sectorActivity: 'Secteur d\'activité',
          subject: 'Sujet',
          message: 'Message',
          content: 'Contenu',
          articleContent: 'Contenu de l\'article',
          description: 'Description',
          summary: 'Résumé',
          excerpt: 'Extrait',
          title: 'Titre',
          titleMain: 'Titre principal',
          mainTitle: 'Titre principal',
          subtitle: 'Sous-titre',
          website: 'Site web',
          websiteUrl: 'URL du site',
          expertise: 'Expertise',
          expertiseTags: 'Expertise (Tags)',
          speakerName: 'Nom de l\'intervenant',
          speaker: 'Intervenant',
          speakerTitle: 'Titre/Poste',
          speakerCompany: 'Entreprise',
          speakerExpertise: 'Expertise (Tags)',
          location: 'Localisation',
          platform: 'Plateforme',
          url: 'URL',
          image: 'Image',
          coverImage: 'Image de couverture',
          tags: 'Tags',
          duration: 'Durée',
          author: 'Auteur',
          sourceUrl: 'URL source'
        },
        placeholders: {
          enterFirstName: 'Votre prénom',
          enterLastName: 'Votre nom',
          enterEmail: 'votre@email.com',
          emailExample: 'contact@votre-organisation.com',
          enterPassword: 'Entrez votre mot de passe',
          enterPhone: '+33 1 23 45 67 89',
          enterAddress: '123 Rue Exemple, 75000 Paris, France',
          enterCity: 'Paris',
          selectCountry: 'Sélectionnez un pays',
          enterCompany: 'Nom de votre entreprise',
          companyExample: 'Tanger Med Logistics',
          countryExample: 'Maroc',
          enterPosition: 'Votre poste',
          positionExample: 'Directeur Partenariats, CEO, etc.',
          selectSector: 'Sélectionnez un secteur',
          enterSubject: 'Sujet',
          enterMessage: 'Votre message ici...',
          enterContent: 'Rédigez votre contenu...',
          enterDescription: 'Rédigez le contenu complet...',
          enterSummary: 'Résumé de l\'article qui apparaîtra dans la liste...',
          enterTitle: 'Titre accrocheur de votre article',
          enterSubtitle: 'ex: Solutions innovantes pour les ports',
          enterWebsite: 'https://www.exemple.com',
          enterExpertise: 'ex: Innovation, IA, Logistique',
          expertiseExample: 'Ex: IA, Blockchain, Logistique',
          enterLocation: 'Ex: Salle principale pavillon',
          enterPlatform: 'ex: YouTube, Vimeo',
          enterUrl: 'https://...',
          enterAuthor: 'Nom de l\'auteur',
          enterSourceUrl: 'https://source-originale.com/article',
          contactForm: 'Formulaire de contact'
        },
        validation: {
          required: 'Ce champ est requis',
          requiredField: 'Ce champ est requis',
          invalidEmail: 'Veuillez entrer une adresse email valide',
          invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
          minLength: 'Minimum {{min}} caractères',
          maxLength: 'Maximum {{max}} caractères',
          passwordNotMatch: 'Les mots de passe ne correspondent pas',
          selectOption: 'Veuillez sélectionner une option',
          fillAllFields: 'Veuillez remplir tous les champs obligatoires'
        }
      },
      dev: {
        subscription_shortcuts: 'Raccourcis Abonnements (DEV)'
      },
      calendar: {
        total_slots: 'Total créneaux',
        this_week: 'Cette semaine',
        available_spots: 'Places disponibles',
        title: 'Planning SIPORTS 2026',
        event_days_description: 'Disponibilités pour les 3 jours de l\'événement',
        export_google: 'Exporter Google Calendar',
        export_outlook: 'Exporter Outlook',
        grid_view: 'Grille',
        list_view: 'Liste',
        default_location: 'Lieu SIPORT',
        details: 'DÉTAILS',
        book: 'RÉSERVER',
        no_slots: 'Aucun créneau',
        plan_availability: 'Planifiez vos disponibilités pour ce jour',
        no_availability: 'Aucune disponibilité définie',
        start_planning: 'Commencez à planifier vos rendez-vous pour les 3 jours de l\'événement',
        create_availability: 'Créer mes disponibilités',
        full: 'COMPLET',
        no_spots_left: 'place restante',
        spots_available: 'places disponibles',
        no_availability_yet: 'Aucune disponibilité pour le moment',
        schedule_slots: 'Planifiez vos créneaux pour faciliter les prises de rendez-vous',
        view_past_slots: 'Voir mes créneaux passés',
        create_my_availability: 'Créer mes disponibilités',
        add_new_slot: 'Ajouter un nouveau créneau',
        no_slots_configured: 'Aucun créneau configuré',
        no_availability_message: 'Vous n\'avez pas encore défini de disponibilités pour les 3 jours du salon SIPORT.',
        create_first_slot: 'Créer mon premier créneau'
      },
      months: {
        january: 'Janvier',
        february: 'Février',
        march: 'Mars',
        april: 'Avril',
        may: 'Mai',
        june: 'Juin',
        july: 'Juillet',
        august: 'Août',
        september: 'Septembre',
        october: 'Octobre',
        november: 'Novembre',
        december: 'Décembre'
      },
      time: {
        hour: 'Heure',
        hours: 'Heures',
        minute: 'Minute',
        minutes: 'Minutes',
        second: 'Seconde',
        seconds: 'Secondes'
      },
      upload: {
        upload_image: 'Télécharger une image',
        upload_images: 'Télécharger des images',
        must_be_image: 'Le fichier doit être une image',
        max_size: 'Taille maximale',
        uploading: 'Téléchargement en cours...',
        upload_success: 'Image téléchargée avec succès',
        upload_error: 'Erreur lors du téléchargement',
        drag_drop: 'Glissez-déposez ou cliquez pour sélectionner',
        select_file: 'Sélectionner un fichier',
        remove_image: 'Supprimer l\'image',
        change_image: 'Changer l\'image',
        max_images_error: 'Vous ne pouvez pas télécharger plus de {{max}} images.',
        file_not_image: 'Le fichier "{{name}}" n\'est pas une image.',
        image_too_large: 'L\'image "{{name}}" est trop volumineuse. Taille maximale: {{max}}MB.',
        images_count: '{{current}} sur {{max}} images ({{size}}MB max par image)'
      },
      form: {
        organization_name: 'Nom de l\'organisation',
        country: 'Pays',
        partnership_type: 'Type de partenariat',
        full_name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone',
        confirm_send: 'Confirmer et envoyer',
        name: 'Nom',
        message: 'Message',
        first_name: 'Prénom',
        last_name: 'Nom',
        company: 'Entreprise',
        position: 'Poste',
        address: 'Adresse',
        city: 'Ville',
        postal_code: 'Code postal',
        description: 'Description',
        title: 'Titre',
        category: 'Catégorie',
        price: 'Prix',
        date: 'Date',
        time: 'Heure',
        location: 'Lieu',
        website: 'Site web',
        your_company: 'Nom de votre société',
        required: 'Requis',
        optional: 'Optionnel',
        verify_information: 'Vérifiez vos informations',
        ensure_correct_before_submit: 'Assurez-vous que toutes les informations sont correctes avant de soumettre votre demande',
        organization_information: 'Informations sur l\'Organisation',
        contact_information: 'Informations de Contact',
        activity_sector: 'Secteur d\'activité',
        request_review_warning: 'Une fois validé, votre demande sera envoyée à notre équipe pour examen. Vérifiez bien que toutes les informations sont exactes avant de continuer.',
        edit_information: 'Modifier les informations',
        confirm_and_send: 'Confirmer et envoyer',
        sending: 'Envoi en cours...'
      },
      countdown: {
        event_started: 'Le salon a commencé !',
        event_welcome: 'SIPORTS 2026 est maintenant ouvert. Bienvenue !',
        opening_in: 'Ouverture dans :',
        opening_description: 'Plus que quelques {{period}} avant l\'ouverture du plus grand salon portuaire international',
        day: 'Jour',
        days: 'Jours',
        days_plural: 'jours',
        hour: 'Heure',
        hours: 'Heures',
        minute: 'Minute',
        minutes: 'Minutes',
        second: 'Seconde',
        seconds: 'Secondes',
        months: 'mois',
        weeks: 'semaines',
        location_access: 'Lieu & Accès',
        venue: 'Venue',
        address: 'Adresse',
        event_address: "Parc d'Exposition Mohammed VI à El Jadida Maroc",
        schedule: 'Horaires',
        key_figures: 'Chiffres Clés',
        exhibitors: 'Exposants',
        visitors: 'Visiteurs',
        countries: 'Pays',
        conferences: 'Conférences',
        program_3days: 'Programme des 3 Jours',
        day1_title: 'Jour 1 - 1er Avril',
        day1_opening: 'Cérémonie d\'ouverture',
        day1_plenary: 'Conférences plénières',
        day1_networking: 'Networking d\'accueil',
        day2_title: 'Jour 2 - 2 Avril',
        day2_workshops: 'Ateliers techniques',
        day2_b2b: 'Sessions B2B',
        day2_demos: 'Démonstrations',
        day3_title: 'Jour 3 - 3 Avril',
        day3_roundtables: 'Tables rondes',
        day3_awards: 'Remise des prix',
        day3_closing: 'Cérémonie de clôture',
        set_reminder: 'Programmer un Rappel',
        reminder_set: 'Rappel programmé : notification 24h avant ouverture, rappel mobile et email configurés, itinéraire inclus.',
        share_countdown: 'Partager le Compte à Rebours',
        share_title: 'SIPORTS 2026 - Compte à Rebours',
        share_text: '🚢 SIPORTS 2026 - Salon International des Ports\n📅 {{dates}}\n📍 {{location}}\n\n⏰ Plus que {{days}} jours, {{hours}} heures !\n\n🌐 https://siportevent.com',
        copied_clipboard: '🔗 Compte à rebours copié dans le presse-papiers !',
        copy_failed: 'Impossible de copier',
        add_to_calendar: 'Ajouter au Calendrier',
        calendar_description: 'Le plus grand salon portuaire international - 300 exposants, 6 000 visiteurs professionnels de 42 pays',
        calendar_added: '📅 Événement ajouté à votre calendrier : SIPORTS 2026, rappels automatiques et itinéraire inclus.',
        practical_info: 'Informations Pratiques',
        info_registration: 'Inscription gratuite pour les visiteurs',
        info_parking: 'Parking gratuit sur site',
        info_shuttles: 'Navettes depuis l\'aéroport',
        info_catering: 'Restauration sur place',
        info_wifi: 'WiFi gratuit dans tout le centre',
        contact_org: 'Contact Organisation',
        contact_hours: 'Lun-Ven: 9h-18h'
      },
      seo: {
        page_title: 'Titre de la page',
        description_placeholder: 'Description de la page qui apparaîtra dans les résultats de recherche...',
        description_help: 'Description concise et attractive de votre page...',
        add_keyword: 'Ajouter un mot-clé...',
        keywords: 'Mots-clés',
        meta_title: 'Meta titre',
        meta_description: 'Meta description',
        preview: 'Aperçu'
      },
      templates: {
        all: 'Tous',
        modern: 'Moderne',
        classic: 'Classique',
        minimal: 'Minimal',
        corporate: 'Corporate'
      },
      editor: {
        main_title: 'Titre principal',
        description: 'Description...',
        product_name: 'Nom produit',
        price: 'Prix',
        email: 'Email',
        phone: 'Téléphone',
        address: 'Adresse',
        section_title: 'Titre de la section',
        add_section: 'Ajouter une section',
        edit_section: 'Modifier la section',
        delete_section: 'Supprimer la section',
        save_changes: 'Enregistrer les modifications',
        preview: 'Aperçu',
        publish: 'Publier'
      },
      whatsapp: {
        need_help: 'Besoin d\'aide ?',
        chat_team: 'Discutez avec notre équipe sur WhatsApp',
        contact_whatsapp: 'Contacter par WhatsApp',
        available_24_7: 'Disponible 24/7'
      },
      quota: {
        remaining_unlimited: '∞ restant',
        remaining: '{{count}} restant',
        remaining_plural: '{{count}} restants',
        unlimited: 'Illimité',
        upgrade_for_more: 'Upgrader pour plus'
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        dashboard: 'Dashboard',
        exhibitors: 'Exhibitors',
        partners: 'Partners',
        pavilions: 'Pavilions',
        information: 'Information',
        events: 'Events',
        news: 'News',
        subscriptions: 'Subscriptions',
        appointments: 'Appointments',
        chat: 'Messages',
        networking: 'Networking',
        profile: 'My Profile',
        accommodation: 'Accommodation'
      },
      menu: {
        pavilions_desc: 'Discover the show pavilions',
        events_desc: 'Calendar of events',
        news_desc: 'News and updates',
        subscriptions_desc: 'Manage your subscriptions',
        accommodation_desc: 'Partner hotels & preferential rates'
      },
      exhibitor_levels: {
        basic_9: '9m² Basic',
        standard_18: '18m² Standard',
        premium_36: '36m² Premium',
        elite_54plus: '54m²+ Elite'
      },
      auth: {
        login: 'Login',
        register: 'Register',
        logout: 'Logout',
        email: 'Email',
        password: 'Password',
        remember_me: 'Remember me',
        forgot_password: 'Forgot password?'
      },
      appointments: {
        book: 'Book',
        cancel: 'Cancel',
        confirm: 'Confirm',
        quota_reached: 'Quota reached ({{current}}/{{max}})',
        booking_success: 'Appointment booked successfully',
        no_slots: 'No slots available',
        calendar: 'Appointment Calendar',
        meeting_with: 'Meeting with {{name}}',
        no_appointments_date: 'No appointments for this date.'
      },
      common: {
        days: {
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat',
          sun: 'Sun'
        },
        events: 'Events',
        connections: 'Connections',
        impressions: 'Impressions',
        interactions: 'Interactions',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        search: 'Search',
        view: 'View',
        view_all: 'View All',
        load_more: 'Load More',
        download: 'Download',
        upload: 'Upload',
        close: 'Close',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        filter: 'Filter',
        export: 'Export',
        import: 'Import',
        refresh: 'Refresh',
        warning: 'Warning',
        close_error: 'Close error message',
        back_to_dashboard: 'Back to Dashboard',
        sending: 'Sending...',
        error_401: 'Unauthorized Access',
        error_401_desc: 'You must be logged in to access this page.',
        error_403: 'Forbidden',
        error_403_desc: 'You don\'t have the necessary permissions to access this resource.'
      },
      actions: {
        accept: 'Accept',
        reject: 'Reject',
        open: 'Open',
        close: 'Close',
        add: 'Add',
        view_details: 'View Details',
        schedule_meeting: 'Schedule Meeting',
        refresh: 'Refresh',
        access: 'Access',
        manage: 'Manage',
        view: 'View',
        edit: 'Edit',
        copy: 'Copy',
        connect: 'Connect',
        message: 'Message',
        view_all: 'View All'
      },
      errors: {
        oops: 'Oops!',
        unexpected_error: 'An unexpected error occurred. We apologize.',
        error_message: 'Error Message',
        view_stack_trace: 'View Stack Trace',
        reload_page: 'Reload Page',
        back_to_home: 'Back to Home',
        accept_appointment: 'Error accepting appointment',
        reject_appointment: 'Error rejecting appointment',
        unregister_event: 'Error unregistering from event',
        unknown_user_type: 'Unknown user type: {{type}}',
        contact_support_resolve: 'Email: {{email}} - Please contact support to resolve this issue'
      },
      dashboard: {
        title: 'Dashboard',
        welcome: 'Welcome',
        overview: 'Overview',
        statistics: 'Statistics',
        recent_activity: 'Recent Activity',
        quick_actions: 'Quick Actions',
        notifications: 'Notifications',
        settings: 'Settings',
        logout: 'Logout',
        your_quotas: 'Your Quotas',
        exhibitor_quotas: 'Your Exhibitor Quotas',
        visit_activity_7days: 'Visit Activity (Last 7 days)',
        appointment_status: 'Appointment Status',
        interest_areas: 'Interest Areas',
        visitor_engagement_7days: 'Visitor Engagement (Last 7 days)',
        brand_exposure_7days: 'Brand Exposure (Last 7 days)',
        engagement_channels: 'Engagement Channels',
        login_to_see_stats: 'Log in to see your statistics.',
        minisite_views: 'Mini-site Views',
        appointments: 'Appointments',
        products: 'Products',
        profile_views: 'Profile Views'
      },
      admin: {
        title: 'Administration',
        dashboard_title: 'Admin Dashboard',
        welcome: 'Welcome, {{name}}',
        system_operational: 'System Operational',
        system_uptime: 'System Uptime',
        api_calls_per_day: 'API Calls/day',
        storage_used: 'Storage Used',
        required_actions: 'Required Actions',
        items_need_attention: '{{count}} items require your attention',
        registration_requests: 'Registration Requests',
        click_to_process: 'Click to process',
        payment_validation: 'Payment Validation',
        manage_proofs: 'Manage proofs',
        exhibitors: 'Exhibitors',
        list_and_subscriptions: 'List & Subscriptions',
        partners: 'Partners',
        list_and_packs: 'List & Packs',
        vip_visitors_management: 'VIP Visitors Management',
        view_list: 'View list',
        content_to_moderate: 'Content to moderate',
        active_contracts: 'Active contracts',
        active_contracts_count: '{{count}} active contracts',
        platform_statistics: 'Platform Statistics',
        total_users: 'Total Users',
        active_users: 'Active users',
        active_users_count: '{{count}} active',
        active_exhibitors: 'Active Exhibitors',
        online_count: '{{count}} online',
        official_partners: 'Official Partners',
        visitors: 'Visitors',
        analysis_trends: 'Analysis & Trends',
        realtime_data: 'Real-time data',
        user_growth_6months: 'User Growth (Last 6 months)',
        user_distribution: 'User Distribution',
        platform_activity_week: 'Platform Activity (This week)',
        weekly_traffic: 'Weekly Traffic',
        visits: 'Visits',
        page_views: 'Page views',
        quick_actions_nav: 'Quick Actions & Navigation',
        participants_management: 'Participants Management',
        create_exhibitor: 'Create exhibitor',
        manage_exhibitors: 'Manage exhibitors',
        create_partner: 'Create partner',
        manage_partners: 'Manage partners',
        publication_control_title: '🔥 PUBLICATION CONTROL - CLIENT VALIDATION MODE',
        publication_control_desc: '⚠️ Activate/Deactivate GLOBAL visibility',
        total_control: 'TOTAL CONTROL',
        content_management: 'Content Management',
        create_event: 'Create event',
        manage_events: 'Manage events',
        create_article: 'Create article',
        manage_articles: 'Manage articles',
        media_management: 'Media Management',
        manage_media: 'Manage media',
        approve_media: 'Approve media',
        synchronization: 'Synchronization',
        synchronizing: 'Synchronizing...',
        sync_articles: 'Sync articles',
        system_health: 'System Health',
        api_calls_24h: 'API Calls (24h)',
        avg_response_time: 'Avg response time',
        recent_system_activity: 'Recent System Activity',
        registered_visitors: 'Registered Visitors',
        conferences_workshops: 'Conferences & Workshops',
        vs_target: '{{percent}} vs target',
        detailed_metrics_performance: 'Detailed Metrics & Performance',
        users: 'Users',
        moderation: 'Moderation',
        analytics: 'Analytics',
        reports: 'Reports',
        settings: 'Settings',
        logs: 'Logs',
        payments: 'Payments',
        content: 'Content',
        revenue: 'Revenue',
        growth: 'Growth'
      },
      exhibitor: {
        title: 'Exhibitor Space',
        dashboard: 'Dashboard',
        products: 'My Products',
        appointments: 'Appointments',
        minisite: 'My Minisite',
        analytics: 'My Analytics',
        leads: 'My Leads',
        messages: 'Messages',
        calendar: 'Calendar',
        profile: 'My Profile',
        subscription: 'My Subscription',
        my_booth: 'My Booth',
        booth_location: 'you are at your booth',
        stats: {
          mini_site_views: 'Mini-Site Views',
          appointments: 'Appointment Requests',
          downloads: 'Downloads',
          messages: 'Messages'
        },
        quick_actions: {
          create_minisite_ai: 'Create Mini-Site with AI',
          create_minisite_ai_desc: 'Automatically generate your mini-site from your website',
          networking_ai: 'AI Networking',
          networking_ai_desc: 'Discover relevant connections with AI',
          edit_minisite: 'Edit my Mini-Site',
          edit_minisite_desc: 'Customize your digital presence',
          profile: 'My Exhibitor Profile',
          profile_desc: 'Update your information',
          qr_code: 'Booth QR Code',
          qr_code_desc: 'Generate your personalized QR code'
        },
        header: {
          published_tooltip_hide: 'Click to hide your profile',
          published_tooltip_show: 'Click to publish your profile',
          changing: '⏳ Changing...',
          published_status: '✓ PUBLISHED - Click to hide',
          hidden_status: '🔒 HIDDEN - Click to publish',
          virtual_badge: 'My Virtual Badge',
          create_edit_minisite: 'Create / Edit my exhibitor mini-site'
        },
        modals: {
          views_title: 'Mini-Site View Details',
          views_chart_title: '📊 View Statistics',
          views_text: 'Your mini-site has been viewed {{count}} times.',
          views_footer: 'View detailed analytics in the Mini-Site section.',
          appointments_title: 'Appointment Requests',
          appointments_chart_title: '📅 Appointments',
          appointments_text: 'You have {{count}} appointments.',
          appointments_action: 'View all appointments',
          downloads_title: 'Document Downloads',
          downloads_chart_title: '📥 Downloaded Documents',
          downloads_text: '{{count}} downloads of your documents.',
          messages_title: 'Messages and Communications',
          messages_chart_title: '💬 Messages',
          messages_text: 'You have {{count}} unread messages.',
          messages_action: 'Open chat'
        },
        activity: {
          view_all: 'Full Activity History',
          none: 'No recent activity found.'
        },
        status: {
          confirmed: 'Confirmed',
          pending: 'Pending',
          completed: 'Completed'
        }
      },
      visitor: {
        title: 'Visitor Space',
        dashboard: 'Dashboard',
        exhibitors: 'Exhibitors',
        events: 'Events',
        appointments: 'My Appointments',
        favorites: 'My Favorites',
        networking: 'Networking',
        badge: 'My Badge',
        subscription: 'Premium Subscription',
        level: 'Level',
        upgrade: 'Upgrade to Premium',
        my_appointments: 'My Appointments',
        my_favorites: 'My Favorites',
        my_tickets: 'My Tickets',
        upgrade_required: 'Upgrade Required',
        schedule_appointment: 'Schedule Appointment',
        appointment_confirmed: 'Appointment Confirmed',
        appointment_declined: 'Appointment Declined',
        no_appointments: 'No Appointments',
        upcoming_events: 'Upcoming Events',
        registered_events: 'Registered Events',
        quota_remaining: 'Remaining Appointments',
        connections: 'Connections',
        welcome_message: 'Welcome {{name}}, level {{level}}',
        connected_status: 'Connected',
        unauthorized_access: 'Unauthorized Access',
        please_login: 'Please login to access your visitor space',
        exhibitors_visited: 'Exhibitors Visited',
        bookmarks: 'Bookmarks',
        messages_sent: 'Messages',
        confirmed: 'Confirmed',
        pending: 'Pending',
        refused: 'Declined',
        interest_areas: 'Areas of Interest',
        visit_activity: 'Visit Activity',
        appointment_status: 'Appointment Status',
        visitor_space: 'Visitor Space',
        my_profile: 'My Profile',
        my_events: 'My Events',
        // New missing keys
        visitor_area: 'Visitor Area',
        my_virtual_badge: 'My Virtual Badge',
        connected: 'Connected',
        b2b_appointments: 'B2B Appointments',
        // VIP Benefits Section
        vip_benefits_title: 'VIP Benefits',
        vip_benefits_subtitle: 'Enjoy exclusive benefits with your VIP status',
        vip_appointments: 'Unlimited Appointments',
        vip_appointments_desc: 'Schedule as many B2B meetings as you want',
        vip_messaging: 'Priority Messaging',
        vip_messaging_desc: 'Contact exhibitors and partners directly',
        vip_badge: 'VIP Badge',
        vip_badge_desc: 'Distinctive badge with access to all zones',
        vip_ai_matching: 'AI Matching',
        vip_ai_matching_desc: 'Personalized recommendations by artificial intelligence',
        vip_webinars: 'Exclusive Webinars',
        vip_webinars_desc: 'Access to premium content and private sessions',
        vip_support_priority: 'Priority Support',
        vip_support_desc: 'Dedicated VIP Assistance',
        vip_news_priority: 'Priority News',
        vip_news_desc: 'Early Access',
        // AI Networking Section
        ai_networking: 'AI Networking',
        ai_networking_desc: 'Discover personalized networking opportunities through our artificial intelligence',
        explore_network: 'Explore Network',
        configure_matching: 'Configure Matching',
        // Appointments Section
        schedule_appointment_desc: 'Organize your B2B appointments with exhibitors and partners',
        program_appointment: 'Schedule Appointment',
        appointments_remaining: 'Remaining Appointments',
        quota_reached: 'Quota reached for {{level}} level. Upgrade to VIP for unlimited appointments!',
        // Activity Section
        your_activity: 'Your Activity',
        your_activity_desc: 'Track your interactions and statistics',
        live: 'LIVE',
        visits: 'Visits',
        interactions: 'Interactions',
        currently: 'Currently',
        previous_period: 'Previous Period',
        confirmed_appointments: 'Confirmed Appointments',
        connections_established: 'Connections Established',
        // Messaging Section
        messaging: 'Messaging',
        messaging_desc: 'Exchange with exhibitors and partners',
        open_messaging: 'Open Messaging',
        // Networking Hub Section
        personal: 'Your Hub',
        networking_hub: 'Personalized Networking',
        networking_hub_desc: 'Grow your professional network',
        my_schedule: 'My Schedule',
        // Events Section
        no_registered_events: 'No registered events',
        appointments_booked: 'Booked Appointments',
        browse_program: 'Browse program',
        view_full_program: 'View Full Program',
        // Premium Feature Section
        premium_feature: 'Premium Feature',
        b2b_reserved_message: 'B2B appointments are reserved for VIP visitors. Upgrade to VIP to unlock this feature and more!',
        upgrade_level: 'Upgrade to VIP Now',
        loading_appointments: 'Loading appointments...',
        // Invitations Section
        new_invitations: 'New Invitations',
        action_required: 'Action Required',
        no_message: 'No message',
        appointment_with: 'appointment with'
      },
      partner: {
        title: 'Partner Space',
        activation_required: 'Activation Required',
        payment_validation_needed: 'Your account is pending payment validation.',
        finalize_payment: 'Finalize Payment',
        payment_validation_required: 'Validation Required',
        payment_activation_message: 'To activate your partner account and access all features, please proceed with your membership payment.',
        make_payment: 'Proceed to Payment',
        access_denied: 'Access Reserved',
        reserved_partners: 'This space is reserved for partners. Please sign in with a partner account.',
        dashboard_live: 'Dashboard Live',
        virtual_badge: 'My Virtual Badge',
        roi_performance: 'ROI Performance',
        hero_title: 'Business Networking Hub',
        hero_subtitle: 'Manage your business opportunities and maximize your impact at SIPORT 2026 event.',
        tabs: {
          overview: 'Overview',
          profile: 'My Booth & Profile',
          networking: 'Appointments',
          analytics: 'ROI Analytics'
        },
        stats: {
          profile_views: 'Profile Views',
          connections: 'Connections',
          appointments: 'Appointments',
          messages: 'Messages'
        },
        quotas: {
          title: 'Quotas & Benefits',
          description: 'Manage your resource consumption.',
          available: 'Available',
          appointments: 'B2B Appointments',
          team_members: 'Team Members',
          media_files: 'Media Files'
        },
        ai_generation: 'AI Generation',
        ai_description: 'Let our AI analyze your website and automatically fill your partner profile with your logos, descriptions, and services.',
        ai_button: 'Auto-Fill with SIPORT AI',
        manual_management: 'Manual Management',
        manual_description: 'Manually edit all details of your partner profile.',
        manual_button: 'Edit Profile',
        edit_basic_info: 'Edit basic information',
        media_catalog: 'Media & Documents Catalog',
        recent_activity: 'Recent Activity',
        appointments_management: 'Appointments Management',
        appointments_description: 'Manage your appointment requests and availability.',
        confirmed_appointments: 'Confirmed Appointments',
        pending: 'Pending',
        pending_requests: '{{count}} pending requests',
        no_pending_requests: 'No pending requests',
        pending_requests_appear_here: 'New requests will appear here',
        accept: 'Accept',
        reject: 'Decline',
        share_scheduling_link: 'Share Scheduling Link',
        share_calendar_description: 'Share your unique link to let visitors book slots directly.',
        copy_virtual_booth_link: 'Copy Virtual Booth Link',
        copy_link_success: 'Link copied!',
        no_message: 'No message',
        analytics_titles: {
          brand_visibility: 'Brand Visibility (7 days)',
          engagement_channels: 'Engagement Channels',
          metrics_distribution: 'Metrics Distribution'
        },
        global_roi_performance: 'Global ROI Performance',
        export_pdf_report: 'Export PDF Report',
        autofill_profile_ai: 'AI Profile Auto-Fill',
        autofill_description: 'Use our AI to extract information from your website.',
        edit_profile_manually: 'Manual Profile Editing',
        update_company_info: 'Update your company information.'
      },
      media: {
        title: 'Media Library',
        menu_title: 'Media',
        webinars: 'Webinars',
        webinars_desc: 'Sponsored webinars replay',
        podcasts: 'Podcasts',
        podcasts_desc: 'SIPORT Talks - Audio episodes',
        videos: 'Videos',
        live: 'Live',
        capsules: 'Inside Capsules',
        capsules_desc: 'Inside SIPORT Video Capsules',
        live_studio: 'Live Studio',
        live_studio_desc: 'Meet The Leaders - Live Interviews',
        best_moments: 'Best Moments',
        best_moments_desc: 'Best moments of the show',
        testimonials: 'Testimonials',
        testimonials_desc: 'Video testimonials',
        library: 'Media Library',
        library_desc: 'All media content',
        categories: 'Categories',
        trending: 'Trending',
        latest: 'Latest',
        watch: 'Watch',
        listen: 'Listen',
        share: 'Share',
        like: 'Like',
        views: 'views',
        duration: 'Duration'
      },
      notifications: {
        title: 'Notifications',
        mark_all_read: 'Mark all as read',
        no_notifications: 'No notifications',
        new: 'New',
        unread: 'Unread',
        settings: 'Notification Settings',
        email_notifications: 'Email Notifications',
        push_notifications: 'Push Notifications',
        sms_notifications: 'SMS Notifications',
        preferences: 'Preferences'
      },
      security: {
        title: 'Security',
        two_factor: 'Two-Factor Authentication',
        enable_2fa: 'Enable 2FA',
        disable_2fa: 'Disable 2FA',
        totp: 'Authenticator App',
        sms: 'SMS',
        email: 'Email',
        backup_codes: 'Backup Codes',
        password: 'Password',
        change_password: 'Change Password',
        change_password_desc: 'Change your temporary password to secure your account.',
        current_password: 'Current password',
        new_password: 'New password',
        confirm_password: 'Confirm new password',
        new_password_placeholder: 'Minimum 8 characters',
        confirm_password_placeholder: 'Re-enter the new password',
        password_requirements: 'Minimum 8 characters. Use letters, numbers and symbols.',
        change_password_btn: 'Update password',
        password_changed: 'Password changed successfully!',
        passwords_mismatch: 'Passwords do not match.',
        password_too_short: 'Password must be at least 8 characters.',
        current_password_wrong: 'Current password is incorrect.',
        fields_required: 'All fields are required.',
        sessions: 'Active Sessions',
        api_keys: 'API Keys',
        audit_logs: 'Audit Logs'
      },
      analytics: {
        title: 'Analytics',
        overview: 'Overview',
        visitors: 'Visitors',
        pageviews: 'Page Views',
        conversions: 'Conversions',
        revenue: 'Revenue',
        export: 'Export',
        period: 'Period',
        today: 'Today',
        week: 'This Week',
        month: 'This Month',
        year: 'This Year',
        custom: 'Custom'
      },
      payments: {
        title: 'Payments',
        methods: 'Payment Methods',
        history: 'History',
        invoices: 'Invoices',
        refunds: 'Refunds',
        pending: 'Pending',
        completed: 'Completed',
        failed: 'Failed',
        amount: 'Amount',
        date: 'Date',
        status: 'Status',
        download_invoice: 'Download Invoice'
      },
      partner_legacy: {
        notFound: 'Partner not found',
        notFoundDesc: "We can't find the partner you are looking for.",
        notFoundGeneric: 'No partner found',
        backToList: 'Back to list',
        discoverSiports: 'Discover SIPORTS',
        areYouPartner: 'Are you a partner?',
        completeProfile: 'Complete your profile for more visibility',
        back_to_dashboard: 'Back to dashboard',
        activation_required: 'Activation Required',
        payment_validation_needed: 'Your account has been created but requires payment validation to activate dashboard access.',
        finalize_payment: 'Finalize Payment',
        access_denied: 'Access Denied',
        reserved_partners: 'This dashboard is reserved for SIPORTS 2026 partners.',
        payment_validation_required: 'Payment Validation Required',
        payment_activation_message: 'To activate all features of your "Premium" partner account, please complete your payment. Access currently limited to proof submission.',
        make_payment: 'Make Payment',
        dashboard_live: 'Dashboard Live',
        ai_generation: 'Intelligent AI Generation',
        appointments_management: 'Appointments Management',
        appointments_description: 'Schedule and manage your B2B business meetings.',
        pending: 'Pending',
        pending_requests: 'Requests to process ({{count}})',
        no_pending_requests: 'No pending requests',
        pending_requests_appear_here: 'New requests will appear here',
        share_calendar_description: 'Share your calendar directly with your clients and prospects to simplify contact scheduling.',
        global_roi_performance: 'Global ROI Performance',
        export_pdf_report: 'Export PDF Report',
        autofill_profile_ai: 'Auto-Fill Profile with AI',
        autofill_description: 'Automatically extract information from your website',
        edit_profile_manually: 'Edit Profile Manually',
        update_company_info: 'Update your company information',
        priority: 'Priority',
        details: 'Details',
        status: {
          upcoming: 'Upcoming',
          draft: 'Draft'
        },
        events: {
          title: 'Sponsored Events',
          subtitle: 'Manage your partner events and track their impact',
          program: 'Partner Events Program',
          available: 'Available events',
          loading: 'Loading events...',
          none: 'No events available at the moment.',
          registered: 'registered',
          capacity: 'Capacity'
        },
        leads: {
          title: 'Leads & Prospects',
          subtitle: 'Manage your qualified leads and track their progress through the sales pipeline',
          premium_program: 'Premium Leads Program',
          conversion_rate: '12% Conversion Rate',
          generated: 'Generated leads',
          qualified: 'Qualified leads',
          conversion: 'Conversion rate',
          estimated_value: 'Estimated value',
          recent: 'Recent Leads',
          exhibitor: 'Exhibitor',
          visitor: 'Visitor',
          other: 'Other',
          connected: 'Connected',
          pending: 'Pending',
          rejected: 'Rejected',
          active_followup: 'Active follow-up',
          awaiting_response: 'Awaiting response',
          sources: {
            events: 'SIPORTS Events',
            networking: 'Partner Networking',
            referrals: 'Client Referrals',
            marketing: 'Marketing Campaigns'
          },
          funnel: {
            generated: 'Generated Leads',
            qualified: 'Qualified',
            proposal: 'Proposal',
            negotiation: 'Negotiation',
            conversion: 'Conversion'
          },
          tips: {
            title: 'Lead Management Tips',
            qualification: 'Quick Qualification',
            qualification_desc: 'Contact hot leads within 24h to maximize your conversion chances',
            followup: 'Regular Follow-up',
            followup_desc: 'Schedule weekly follow-up points to maintain engagement',
            personalization: 'Personalization',
            personalization_desc: 'Adapt your proposals to each prospect\'s specific needs',
            measure: 'Results Measurement',
            measure_desc: 'Regularly analyze your conversion rates to optimize your approach'
          }
        },
        activity: {
          title: 'Partner Activity',
          subtitle: 'Track all your interactions and engagements at SIPORTS',
          full_history: 'Complete Activity History',
          realtime: 'Real-Time',
          history: 'Activity History',
          no_activity: 'No activity found',
          try_filters: 'Try adjusting your search filters',
          just_now: 'Just now',
          hours_ago: '{{count}}h ago',
          days_ago: '{{count}}d ago',
          stats: {
            total: 'Total activities',
            today: 'Today',
            this_week: 'This week'
          },
          filter: {
            all: 'All activities',
            networking: 'Networking',
            communication: 'Communication',
            events: 'Events',
            sponsorship: 'Sponsorship',
            engagement: 'Engagement',
            content: 'Content',
            meetings: 'Meetings',
            system: 'System'
          },
          type: {
            connection: 'Connection',
            message: 'Message',
            event: 'Event',
            sponsorship: 'Sponsorship',
            consultation: 'Consultation',
            content: 'Content',
            alert: 'Alert',
            meeting: 'Meeting'
          },
          connection_established: 'New connection established',
          connected_with: 'You are now connected with Port Solutions Inc.',
          new_message: 'New message received',
          message_from: 'TechMarine Solutions sent you a message',
          event_participation: 'Event participation',
          participated_in: 'You participated in the conference "Digital Transformation in Ports"',
          sponsoring_activated: 'Sponsorship activated',
          logo_displayed: 'Your logo is now displayed on the homepage',
          profile_viewed: 'Profile viewed',
          views_today: 'Your profile was viewed 15 times today',
          content_shared: 'Content shared',
          article_shared: 'Your article "Innovation in Maritime Technology" was shared',
          system_alert: 'System alert',
          metrics_update: 'Performance metrics update available',
          meeting_scheduled: 'Meeting scheduled',
          meeting_confirmed: 'Meeting confirmed with LogiFlow Systems tomorrow at 2pm'
        },
        calendar: {
          title: 'Appointment Calendar',
          create_slot: 'New Slot',
          slot_date_restriction: 'Slots must be created between April 1-3, 2026',
          date_outside_salon: 'Date must be between April 1-3, 2026'
        }
      },
      contact: {
        title: 'Contact Us',
        subtitle: 'Our team is here to help',
        form_title: 'Contact Form',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        company: 'Company',
        subject: 'Subject',
        message: 'Message',
        send: 'Send',
        sending: 'Sending...',
        required_fields: 'Please fill in all required fields',
        invalid_email: 'Please enter a valid email address',
        min_message_length: 'Message must be at least 10 characters',
        success_title: 'Message Sent!',
        success_message: 'We will get back to you as soon as possible',
        error_message: 'An error occurred. Please try again later.',
        subjects: {
          general: 'General Inquiry',
          exhibitor: 'Exhibitor Information',
          visitor: 'Visitor Information',
          technical: 'Technical Support',
          partnership: 'Partnership'
        },
        info: {
          email: 'contact@siportevent.com',
          phone: '+213 XXX XXX XXX',
          address: 'Algiers, Algeria'
        }
      },
      venue: {
        title: 'Event Venue',
        subtitle: 'Discover where SIPORTS 2026 will take place',
        location: 'Location',
        dates: 'Dates',
        opening_hours: 'Opening Hours',
        access: 'Access',
        parking: 'Parking',
        public_transport: 'Public Transport',
        directions: 'Directions',
        map: 'Site Map',
        facilities: 'Facilities',
        wifi: 'Free WiFi',
        restaurants: 'Restaurants',
        restrooms: 'Restrooms'
      },
      accommodation: {
        badge: 'Partner Hotels',
        title: 'Accommodation in El Jadida',
        subtitle: 'Enjoy preferential rates at our partner hotels',
        hotels_partners: 'Partner hotels',
        vip_discount: 'VIP Discount',
        april_dates: 'April 2026',
        vip_advantage_title: '🌟 VIP Visitor Advantage',
        vip_advantage_desc: 'As a VIP visitor, benefit from exclusive preferential rates at all our partner hotels',
        vip_benefit_1: 'Up to -20% off all hotels',
        vip_benefit_2: 'Priority reservation guaranteed',
        vip_benefit_3: 'Free upgrade subject to availability',
        featured_partner: '⭐ Premium Partner',
        standard_rate: 'Standard Rate',
        vip_rate: 'VIP Rate',
        per_night: 'per night',
        view_details: 'View details',
        amenity_wifi: 'Free WiFi',
        amenity_parking: 'Parking',
        amenity_pool: 'Swimming Pool',
        amenity_spa: 'Spa',
        amenity_restaurant: 'Restaurant',
        amenity_gym: 'Fitness Center',
        amenity_casino: 'Casino',
        amenity_beach: 'Beach Access',
        amenity_golf: 'Golf',
        amenity_bar: 'Bar',
        amenity_terrace: 'Terrace',
        how_to_book: 'How to book?',
        step1_title: 'Choose your hotel',
        step1_desc: 'Select the hotel that meets your needs',
        step2_title: 'Contact the hotel',
        step2_desc: 'Call directly or send an email',
        step3_title: 'Mention SIPORTS',
        step3_desc: 'Provide the code "SIPORTS2026" for the preferential rate',
        step4_title: 'Confirm your reservation',
        step4_desc: 'Receive your confirmation by email',
        need_help: 'Need help booking?',
        contact_desc: 'Our team is available to assist you'
      },
      badge: {
        title: 'My Badge',
        subtitle: 'Event Access Badge',
        qr_code: 'QR Code',
        download: 'Download',
        print: 'Print',
        scan_instructions: 'Present this QR code at the entrance',
        visitor_info: 'Visitor Information',
        level_info: 'Level',
        valid_dates: 'Valid from April 1-3, 2026',
        access_granted: 'Access Granted',
        upgrade_to_premium: 'Upgrade to Premium for more benefits',
        loading_badge: 'Loading your badge...',
        access_badge: 'Access Badge',
        unknown_level: 'Unknown level',
        automatic_rotation: 'Automatic rotation',
        secure_qr_jwt: 'Secure JWT QR Code',
        authorized_zones: 'Authorized Zones',
        total_access: 'Total Access',
        regenerate_qr: 'Regenerate QR Code',
        max_security: 'Maximum Security',
        security_info: 'Your QR code automatically regenerates every 30 seconds for optimal security. Never share your badge.',
        my_access_badge: 'My Access Badge',
        download_print_info: 'Download or print your badge to access the event.',
        generate_badge_info: 'Generate your personalized badge with QR code to access the event.',
        generating: 'Generating...',
        generate_my_badge: 'Generate my badge',
        download_png: 'Download PNG',
        regenerating: 'Regenerating...',
        regenerate: 'Regenerate',
        badge_generated_success: 'Badge generated successfully!',
        badge_downloaded: 'Badge downloaded!',
        download_error: 'Download error. Please take a screenshot of the badge.',
        error_loading: 'Error loading badge',
        error_generating: 'Error generating badge',
        login_required: 'Login Required',
        must_login_badge: 'You must be logged in to view your badge.',
        stand_number: 'Stand No.',
        valid_from: 'Valid from',
        usage_instructions: 'Usage Instructions',
        instruction_1: 'Download',
        instruction_1_desc: 'your badge or print it.',
        instruction_2: 'Keep',
        instruction_2_desc: 'the badge on your phone.',
        instruction_3: 'Present',
        instruction_3_desc: 'the QR code at the entrance.',
        instruction_4: 'Wear',
        instruction_4_desc: 'your badge visibly.',
        vip_advantages: 'VIP Advantages',
        vip_advantage_1: 'Unlimited access to all zones',
        vip_advantage_2: 'Unlimited B2B appointments',
        vip_advantage_3: 'Access to exclusive events',
        statistics: 'Statistics',
        scans_done: 'Scans performed',
        status: 'Status',
        active: 'Active',
        last_scan: 'Last scan'
      },
      profile: {
        not_found: 'Profile not found',
        edit_profile: 'Edit Profile',
        change_photo: 'Change profile photo',
        about_placeholder: 'Tell us about yourself and your expertise...',
        first_name: 'First Name',
        last_name: 'Last Name',
        position: 'Position',
        country: 'Country',
        company_name: 'Your company name',
        company_placeholder: 'Ex: Independent Consultant',
        sector_placeholder: 'Ex: Maritime Consulting',
        click_to_edit: 'Click to edit'
      },
      products: {
        min_one_image: 'Please upload at least one image for this product',
        error_saving_images: 'Error saving images',
        product_images: 'Product Images',
        upload_images_desc: 'Upload photos of your product. The first image will be used as the main image. You can reorder images by drag and drop.'
      },
      siteBuilder: {
        search_template: 'Search for a template...',
        search_image: 'Search for an image...',
        main_title: 'Main Title',
        subtitle: 'Subtitle',
        button_text: 'Button Text',
        product_name: 'Product Name',
        price: 'Price',
        author: 'Author',
        section_title: 'Title',
        description: 'Description...',
        video_url: 'YouTube/Vimeo video URL',
        custom_html: 'Custom HTML code',
        seo_title_placeholder: 'ex: Your Company - Innovative Solutions',
        seo_description_placeholder: 'Concise and attractive page description...',
        seo_slug_placeholder: 'your-page',
        add_keyword: 'Add a keyword...',
        og_image_placeholder: 'https://example.com/image.jpg'
      },
      minisite: {
        click_to_edit: 'Click to edit',
        delete_section: 'Delete section',
        delete_product: 'Delete this product',
        change_image: 'Click to change image',
        delete_image: 'Delete image',
        delete_article: 'Delete this article',
        section_title: 'Section title',
        company_description: 'Your company description',
        feature: 'Feature',
        products_section_title: 'Products section title',
        upload_images: 'Image and media upload',
        // Wizard labels
        step_company: 'Company Name',
        step_logo: 'Logo',
        step_description: 'Description',
        step_documents: 'Documents (PDF, Brochure...)',
        step_products: 'Main Products',
        step_socials: 'Social Media',
        // Placeholders
        placeholder_company: 'Your company',
        placeholder_description: 'Describe your business...',
        placeholder_products: 'List your flagship products...',
        placeholder_socials: 'LinkedIn, Facebook link...',
        placeholder_url: 'https://yoursite.com',
        // Titles & Headers
        wizard_title: '🚀 Creating your mini-site',
        auto_creation_title: '✨ Automatic creation from your website',
        manual_alternative: 'Or fill in the information manually',
        // Buttons
        auto_generate_button: '🚀 Create my mini-site automatically',
        generating_auto: 'Automatic generation in progress...',
        generate_button: 'Generate my mini-site',
        generating: 'Generation in progress...',
        button_previous: 'Previous',
        button_next: 'Next',
        // Success
        success_emoji: '🎉',
        success_title: 'Mini-site successfully generated!',
        success_message: 'You can now customize or share it.',
        view_my_minisite: 'View my mini-site',
        back_to_dashboard: 'Back to dashboard',
        // Errors
        invalid_url: 'Invalid URL',
        timeout_error: 'The site {{domain}} is taking too long to respond. Please try again or use manual mode.',
        not_accessible_error: 'The site {{domain}} is not accessible. Check the URL and try again.',
        ai_unavailable: 'The automatic generation service is temporarily unavailable. Please use manual mode or try again later.',
        fetch_error: 'Unable to retrieve site information. {{message}}',
        unknown_error: 'Unknown error',
        login_required: 'You must be logged in to create a mini-site',
        creation_error: 'Error creating mini-site.',
        error_title: 'Error',
        // AI Info
        ai_info: '🤖 Our AI will automatically retrieve: name, logo, description, products, contacts and social media.',
        // Fallback
        default_company: 'Company'
      },
      minisite_editor: {
        // Page titles & headers
        page_title: 'Mini-Site Editor',
        page_subtitle: 'Customize your mini-site in real-time',
        back_to_dashboard: 'Back to dashboard',
        preview: 'Preview',
        save: 'Save',
        saving: 'Saving...',
        // Section types
        section_hero: 'Hero Section',
        section_about: 'About',
        section_products: 'Products',
        section_gallery: 'Gallery',
        section_news: 'News',
        section_contact: 'Contact',
        section_products_services: 'Products & Services',
        // Section descriptions
        desc_hero: 'Welcome banner with title and CTA',
        desc_about: 'Your company presentation',
        desc_products: 'Your products and services catalog',
        desc_gallery: 'Company photos and videos',
        desc_news: 'Latest news and announcements',
        desc_contact: 'Contact information and form',
        // Default content
        default_your_title: 'Your title',
        default_your_subtitle: 'Your subtitle',
        default_learn_more: 'Learn more',
        default_about_us: 'About us',
        default_describe_company: 'Describe your company here...',
        default_feature_1: 'New feature 1',
        default_feature_2: 'New feature 2',
        default_our_products: 'Our products',
        default_gallery_title: 'Gallery',
        default_news_title: 'News',
        default_contact_us: 'Contact us',
        default_your_address: 'Your address',
        default_your_phone: 'Your phone',
        default_your_email: 'your@email.com',
        default_your_website: 'https://your-site.com',
        default_your_hours: 'Your hours',
        default_new_product: 'New product',
        default_product_desc: 'Product description',
        default_feature: 'Feature',
        default_on_quote: 'On quote',
        default_new_section: 'New section',
        // Example data (keep French for now as they're example company data)
        example_company_name: 'Port Solutions Inc.',
        example_company_subtitle: 'Leading provider of integrated port management solutions',
        example_discover_solutions: 'Discover our solutions',
        example_our_expertise: 'Our expertise',
        example_expertise_desc: 'With over 20 years of experience in the port sector, we support ports worldwide in their digital transformation.',
        example_innovative_solutions: 'Innovative solutions',
        example_recognized_expertise: 'Recognized expertise',
        example_support_24_7: '24/7 Support',
        example_international_presence: 'International presence',
        example_our_solutions: 'Our solutions',
        example_product_1_name: 'Maritime AI System',
        example_product_1_desc: 'Intelligent platform for optimizing port operations with predictive AI',
        example_product_1_feat_1: 'Real-time predictive analytics',
        example_product_1_feat_2: 'AI automation',
        example_product_1_feat_3: 'Complete API integration',
        example_product_2_name: 'Connected IoT Platform',
        example_product_2_desc: 'IoT solution for supervision and monitoring of port equipment',
        example_product_2_feat_1: 'Smart sensors',
        example_product_2_feat_2: 'Predictive maintenance',
        example_product_2_feat_3: 'Instant alerts',
        example_product_3_name: '24/7 Premium Support',
        example_product_3_desc: 'Dedicated technical assistance and continuous training for your teams',
        example_product_3_feat_1: 'Multilingual dedicated team',
        example_product_3_feat_2: 'Intervention within 2h',
        example_product_3_feat_3: 'Personalized training',
        example_price_from: 'From €15,000',
        example_price_monthly: '€2,500/month',
        example_address: '123 Port Avenue, Casablanca, Morocco',
        example_hours: 'Mon-Fri: 8am-6pm',
        // Actions & buttons
        add_section: 'Add section',
        add_section_hero: 'Add Hero Section',
        add_product: 'Add product',
        remove_section: 'Remove section',
        hide_section: 'Hide section',
        show_section: 'Show section',
        click_to_edit: 'Click to edit',
        edit_field: 'Edit this field',
        save_changes: 'Save',
        cancel_changes: 'Cancel',
        // Sidebar
        site_settings: 'Site settings',
        primary_color: 'Primary color',
        font_family: 'Font',
        logo_url: 'Logo URL',
        upload_logo: 'Upload logo',
        add_sections: 'Add sections',
        sections_list: 'Sections',
        color_picker_label: 'Primary color picker',
        color_hex_label: 'Primary color hex code',
        // Confirmations
        confirm_delete_section: 'Are you sure you want to delete section "{{title}}"?',
        confirm_delete_product: 'Are you sure you want to delete this product?',
        // Success messages
        section_added: '✅ SECTION ADDED — {{title}}',
        section_deleted: 'Section deleted: "{{title}}". Order reorganized.',
        section_visibility_changed: 'Visibility changed: {{title}} ({{visibility}})',
        section_visible: 'Visible',
        section_hidden: 'Hidden',
        product_added: '✅ Product added.',
        product_deleted: 'Product deleted.',
        changes_saved: '✅ Mini-site saved successfully!',
        // Error messages
        no_exhibitor_found: 'No exhibitor found for this user',
        error_loading_minisite: 'Unable to load mini-site',
        error_saving_minisite: 'Error saving',
        must_be_exhibitor: 'You must be logged in as an exhibitor to save',
        must_be_logged_in: 'You must be logged in',
        // Empty states
        no_sections_message: 'Add sections to start creating your mini-site',
        // Instructions
        instructions_title: '💡 How to use the editor',
        instructions_edit_title: '✏️ Text editing:',
        instructions_edit_1: '• Click on any text to edit it',
        instructions_edit_2: '• Type your new content',
        instructions_edit_3: '• Click "Save" to confirm',
        instructions_edit_4: '• Click "Cancel" to revert to original text',
        instructions_sections_title: '🎨 Section management:',
        instructions_sections_1: '• Add sections from the sidebar',
        instructions_sections_2: '• Click the eye icon to hide/show',
        instructions_sections_3: '• Use the trash icon to delete',
        instructions_sections_4: '• Drag and drop to reorganize',
        instructions_media_title: '🖼️ Images and media:',
        instructions_media_1: '• Click on an image to change it',
        instructions_media_2: '• Supported formats: JPG, PNG, WebP',
        instructions_media_3: '• Max recommended size: 2MB',
        instructions_media_4: '• Automatic optimization'
      },
      ui: {
        search: 'Search...',
        uploading: 'Uploading...',
        filtered_count: 'Filtered count',
        search_by: 'Search by name, email, company or reference...',
        click_to_change: 'Click to change',
        view: 'View',
        share_article: 'Share article',
        share_event: 'Share this event',
        back_to_top: 'Back to top',
        sync_official: 'Sync with official SIPORTS website',
        contact_directly: 'Contact directly',
        book_appointment: 'Book appointment',
        add_remove_favorite: 'Add/Remove from favorites',
        contact_info: 'Contact information',
        forward_10s: 'Forward 10s',
        backward_10s: 'Backward 10s'
      },
      partner_edit: {
        basic_info: 'Basic Information',
        contact_info: 'Contact Information',
        sectors_services: 'Sectors & Services',
        expertise: 'Our Expertise',
        projects: 'Projects & Achievements',
        gallery: 'Photo Gallery',
        news: 'News & Announcements',
        metrics: 'Impact & Metrics',
        timeline: 'History & Timeline',
        team: 'Our Team',
        admin_only: 'Only administrators can modify sponsorship level',
        company_example: 'Tanger Med Logistics',
        country_example: 'Morocco',
        website_placeholder: 'https://your-website.com',
        description_example: 'Premium logistics partner of Tanger Med port, offering international storage and distribution services.'
      },
      admin_media: {
        manager_title: 'Admin Media Manager',
        create_title_example: 'Ex: Webinar - Port Innovation 2026',
        create_description_placeholder: 'Detailed content description...',
        url_placeholder: 'https://...',
        duration_example: 'Ex: 3600',
        tags_example: 'innovation, technology, digital',
        reject_reason: 'Explain why this media is rejected...'
      },
      social: {
        follow_facebook: 'Follow us on Facebook',
        follow_twitter: 'Follow us on Twitter',
        follow_linkedin: 'Follow us on LinkedIn',
        youtube_channel: 'SIPORTS YouTube Channel'
      },
      networking: {
        search_room: 'Search for a room...',
        ai_reserved_premium: 'AI-powered networking is reserved for Premium and VIP members. Boost your experience and discover strategic connections.',
        excellent_match: 'Excellent match',
        good_match: 'Good match',
        potential_match: 'Potential match',
        low_match: 'Low match'
      },
      registration: {
        name: 'Name',
        bio: 'Bio'
      },
      forms: {
        labels: {
          firstName: 'First Name',
          lastName: 'Last Name',
          email: 'Email',
          emailAddress: 'Email Address',
          password: 'Password',
          passwordConfirm: 'Confirm Password',
          phone: 'Phone',
          address: 'Address',
          city: 'City',
          country: 'Country',
          company: 'Company',
          companyName: 'Company Name',
          organizationName: 'Organization Name',
          position: 'Position',
          positionFunction: 'Position / Function',
          function: 'Function',
          sector: 'Sector',
          sectorActivity: 'Sector of Activity',
          subject: 'Subject',
          message: 'Message',
          content: 'Content',
          articleContent: 'Article Content',
          description: 'Description',
          summary: 'Summary',
          excerpt: 'Excerpt',
          title: 'Title',
          titleMain: 'Main Title',
          mainTitle: 'Main Title',
          subtitle: 'Subtitle',
          website: 'Website',
          websiteUrl: 'Website URL',
          expertise: 'Expertise',
          expertiseTags: 'Expertise (Tags)',
          speakerName: 'Speaker Name',
          speaker: 'Speaker',
          speakerTitle: 'Title/Position',
          speakerCompany: 'Company',
          speakerExpertise: 'Expertise (Tags)',
          location: 'Location',
          platform: 'Platform',
          url: 'URL',
          image: 'Image',
          coverImage: 'Cover Image',
          tags: 'Tags',
          duration: 'Duration',
          author: 'Author',
          sourceUrl: 'Source URL'
        },
        placeholders: {
          enterFirstName: 'Your first name',
          enterLastName: 'Your last name',
          enterEmail: 'your@email.com',
          emailExample: 'contact@your-organization.com',
          enterPassword: 'Enter your password',
          enterPhone: '+33 1 23 45 67 89',
          enterAddress: '123 Example Street, 75000 Paris, France',
          enterCity: 'Paris',
          selectCountry: 'Select a country',
          enterCompany: 'Your company name',
          companyExample: 'Tanger Med Logistics',
          countryExample: 'Morocco',
          enterPosition: 'Your position',
          positionExample: 'Partnership Director, CEO, etc.',
          selectSector: 'Select a sector',
          enterSubject: 'Subject',
          enterMessage: 'Your message here...',
          enterContent: 'Write your content...',
          enterDescription: 'Write the full content...',
          enterSummary: 'Article summary that will appear in the list...',
          enterTitle: 'Catchy title for your article',
          enterSubtitle: 'ex: Innovative solutions for ports',
          enterWebsite: 'https://www.example.com',
          enterExpertise: 'ex: Innovation, AI, Logistics',
          expertiseExample: 'Ex: AI, Blockchain, Logistics',
          enterLocation: 'Ex: Main hall, pavilion',
          enterPlatform: 'ex: YouTube, Vimeo',
          enterUrl: 'https://...',
          enterAuthor: 'Author name',
          enterSourceUrl: 'https://original-source.com/article',
          contactForm: 'Contact form'
        },
        validation: {
          required: 'This field is required',
          requiredField: 'This field is required',
          invalidEmail: 'Please enter a valid email address',
          invalidPhone: 'Please enter a valid phone number',
          minLength: 'Minimum {{min}} characters',
          maxLength: 'Maximum {{max}} characters',
          passwordNotMatch: 'Passwords do not match',
          selectOption: 'Please select an option',
          fillAllFields: 'Please fill in all required fields'
        }
      },
      dev: {
        subscription_shortcuts: 'Subscription Shortcuts (DEV)'
      },
      calendar: {
        total_slots: 'Total slots',
        this_week: 'This week',
        available_spots: 'Available spots',
        title: 'SIPORTS 2026 Schedule',
        event_days_description: 'Availability for the 3 days of the event',
        export_google: 'Export to Google Calendar',
        export_outlook: 'Export to Outlook',
        grid_view: 'Grid',
        list_view: 'List',
        default_location: 'SIPORT Venue',
        details: 'DETAILS',
        book: 'BOOK',
        no_slots: 'No slots',
        plan_availability: 'Schedule your availability for this day',
        no_availability: 'No availability set',
        start_planning: 'Start planning your appointments for the 3 days of the event',
        create_availability: 'Create my availability',
        full: 'FULL',
        no_spots_left: 'spot left',
        spots_available: 'spots available',
        no_availability_yet: 'No availability yet',
        schedule_slots: 'Schedule your slots to facilitate appointment bookings',
        view_past_slots: 'View my past slots',
        create_my_availability: 'Create my availability',
        add_new_slot: 'Add a new slot',
        no_slots_configured: 'No slots configured',
        no_availability_message: 'You have not yet defined any availability for the 3 days of the SIPORT event.',
        create_first_slot: 'Create my first slot'
      },
      months: {
        january: 'January',
        february: 'February',
        march: 'March',
        april: 'April',
        may: 'May',
        june: 'June',
        july: 'July',
        august: 'August',
        september: 'September',
        october: 'October',
        november: 'November',
        december: 'December'
      },
      time: {
        hour: 'Hour',
        hours: 'Hours',
        minute: 'Minute',
        minutes: 'Minutes',
        second: 'Second',
        seconds: 'Seconds'
      },
      upload: {
        upload_image: 'Upload an image',
        upload_images: 'Upload images',
        must_be_image: 'File must be an image',
        max_size: 'Maximum size',
        uploading: 'Uploading...',
        upload_success: 'Image uploaded successfully',
        upload_error: 'Upload error',
        drag_drop: 'Drag and drop or click to select',
        select_file: 'Select a file',
        remove_image: 'Remove image',
        change_image: 'Change image',
        max_images_error: 'You cannot upload more than {{max}} images.',
        file_not_image: 'The file "{{name}}" is not an image.',
        image_too_large: 'The image "{{name}}" is too large. Maximum size: {{max}}MB.',
        images_count: '{{current}} of {{max}} images ({{size}}MB max per image)'
      },
      form: {
        organization_name: 'Organization name',
        country: 'Country',
        partnership_type: 'Partnership type',
        full_name: 'Full name',
        email: 'Email',
        phone: 'Phone',
        confirm_send: 'Confirm and send',
        name: 'Name',
        message: 'Message',
        first_name: 'First name',
        last_name: 'Last name',
        company: 'Company',
        position: 'Position',
        address: 'Address',
        city: 'City',
        postal_code: 'Postal code',
        description: 'Description',
        title: 'Title',
        category: 'Category',
        price: 'Price',
        date: 'Date',
        time: 'Time',
        location: 'Location',
        website: 'Website',
        your_company: 'Your company name',
        required: 'Required',
        optional: 'Optional',
        verify_information: 'Verify Your Information',
        ensure_correct_before_submit: 'Make sure all information is correct before submitting your request',
        organization_information: 'Organization Information',
        contact_information: 'Contact Information',
        activity_sector: 'Activity Sector',
        request_review_warning: 'Once validated, your request will be sent to our team for review. Please ensure all information is accurate before continuing.',
        edit_information: 'Edit Information',
        confirm_and_send: 'Confirm and Send',
        sending: 'Sending...'
      },
      countdown: {
        event_started: 'The event has started!',
        event_welcome: 'SIPORTS 2026 is now open. Welcome!',
        opening_in: 'Opening in:',
        opening_description: 'Only a few {{period}} left before the opening of the largest international port exhibition',
        day: 'Day',
        days: 'Days',
        days_plural: 'days',
        hour: 'Hour',
        hours: 'Hours',
        minute: 'Minute',
        minutes: 'Minutes',
        second: 'Second',
        seconds: 'Seconds',
        months: 'months',
        weeks: 'weeks',
        location_access: 'Location & Access',
        venue: 'Venue',
        address: 'Address',
        event_address: 'Mohammed VI Exhibition Park, El Jadida, Morocco',
        schedule: 'Schedule',
        key_figures: 'Key Figures',
        exhibitors: 'Exhibitors',
        visitors: 'Visitors',
        countries: 'Countries',
        conferences: 'Conferences',
        program_3days: '3-Day Program',
        day1_title: 'Day 1 - April 1st',
        day1_opening: 'Opening ceremony',
        day1_plenary: 'Plenary conferences',
        day1_networking: 'Welcome networking',
        day2_title: 'Day 2 - April 2nd',
        day2_workshops: 'Technical workshops',
        day2_b2b: 'B2B sessions',
        day2_demos: 'Demonstrations',
        day3_title: 'Day 3 - April 3rd',
        day3_roundtables: 'Round tables',
        day3_awards: 'Award ceremony',
        day3_closing: 'Closing ceremony',
        set_reminder: 'Set a Reminder',
        reminder_set: 'Reminder scheduled: notification 24h before opening, mobile and email reminders configured, directions included.',
        share_countdown: 'Share the Countdown',
        share_title: 'SIPORTS 2026 - Countdown',
        share_text: '🚢 SIPORTS 2026 - International Port Exhibition\n📅 {{dates}}\n📍 {{location}}\n\n⏰ Only {{days}} days, {{hours}} hours left!\n\n🌐 https://siportevent.com',
        copied_clipboard: '🔗 Countdown copied to clipboard!',
        copy_failed: 'Unable to copy',
        add_to_calendar: 'Add to Calendar',
        calendar_description: 'The largest international port exhibition - 300 exhibitors, 6,000 professional visitors from 42 countries',
        calendar_added: '📅 Event added to your calendar: SIPORTS 2026, automatic reminders and directions included.',
        practical_info: 'Practical Information',
        info_registration: 'Free registration for visitors',
        info_parking: 'Free on-site parking',
        info_shuttles: 'Shuttles from the airport',
        info_catering: 'On-site catering',
        info_wifi: 'Free WiFi throughout the center',
        contact_org: 'Organization Contact',
        contact_hours: 'Mon-Fri: 9am-6pm'
      },
      seo: {
        page_title: 'Page title',
        description_placeholder: 'Page description that will appear in search results...',
        description_help: 'Concise and attractive description of your page...',
        add_keyword: 'Add a keyword...',
        keywords: 'Keywords',
        meta_title: 'Meta title',
        meta_description: 'Meta description',
        preview: 'Preview'
      },
      whatsapp: {
        need_help: 'Need help?',
        chat_team: 'Chat with our team on WhatsApp',
        contact_whatsapp: 'Contact via WhatsApp',
        available_24_7: 'Available 24/7'
      },
      quota: {
        remaining_unlimited: '∞ remaining',
        remaining: '{{count}} remaining',
        remaining_plural: '{{count}} remaining',
        unlimited: 'Unlimited',
        upgrade_for_more: 'Upgrade for more'
      },
      templates: {
        all: 'All',
        modern: 'Modern',
        classic: 'Classic',
        minimal: 'Minimal',
        corporate: 'Corporate'
      },
      editor: {
        main_title: 'Main title',
        description: 'Description...',
        product_name: 'Product name',
        price: 'Price',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        section_title: 'Section title',
        add_section: 'Add section',
        edit_section: 'Edit section',
        delete_section: 'Delete section',
        save_changes: 'Save changes',
        preview: 'Preview',
        publish: 'Publish'
      },
      marketing: {
        title: 'Content Strategy Hub',
        subtitle: 'Manage SIPORT 2026 narrative experience. Publish impactful content and analyze engagement.',
        badge: 'MARKETING CONTROL CENTER',
        btn_new_content: 'New Content',
        tabs: {
          media_library: 'Media Library',
          articles_news: 'Articles & News',
          explore: 'Explore'
        },
        stats: {
          total_media: 'Total Media',
          webinars: 'Webinars',
          podcasts: 'Podcasts',
          capsules: 'Capsules',
          online: 'Online',
          drafts: 'Drafts',
          total: 'Total'
        },
        filters: {
          filter_by: 'Filter by:',
          status: 'Status:',
          all: 'All',
          webinars: 'Webinars',
          podcasts: 'Podcasts',
          capsules: 'Capsules',
          published: 'Published',
          drafts: 'Drafts'
        },
        media: {
          add_media: 'Add Media',
          no_media_found: 'No media found',
          no_media_desc: 'Add photos, videos or podcasts to get started',
          published: '✅ Published',
          draft: '📝 Draft',
          publish: 'Publish',
          unpublish: 'Unpublish',
          copy: 'Copy',
          copied: 'Shortcode copied!',
          deleted: '🗑️ Media deleted',
          added: '✅ Media added',
          error_update: 'Update error',
          error_delete: 'Delete error',
          title: 'Title',
          description: 'Description',
          type: 'Media Type',
          video_url: 'Video / Audio URL',
          shortcode_copied: '📋 Shortcode copied!'
        },
        articles: {
          title: 'Articles Management',
          subtitle: 'Create and manage articles for siportevent.com',
          create_new: 'Create New Article',
          published_count: 'Published',
          drafts_count: 'Drafts',
          shortcodes_info: 'Using Shortcodes',
          shortcodes_desc: 'Copy an article shortcode and paste it into any siportevent.com page. The article will automatically display with its formatting.',
          example: 'Example:',
          no_articles: 'No articles yet',
          author: 'Author',
          category: 'Category',
          edit: 'Edit',
          publish: 'Publish',
          unpublish: 'Unpublish',
          delete: 'Delete',
          published_badge: '✅ Published',
          draft_badge: '📝 Draft'
        }
      },
      // ===== USER MANAGEMENT PAGE (EN) =====
      users: {
        page: {
          title: 'User Management',
          subtitle: 'Manage user accounts on the SIPORTS platform',
          badge: 'User Management',
          totalUsers: 'Total Users',
          activeAccounts: 'Active Accounts',
          pending: 'Pending',
          suspended: 'Suspended',
          exhibitors: 'Exhibitors',
          partners: 'Partners',
          visitors: 'Visitors',
          administrators: 'Administrators',
          typeExhibitor: 'Exhibitor',
          typePartner: 'Partner',
          typeVisitor: 'Visitor',
          typeAdministrator: 'Administrator',
          statusActive: 'Active',
          statusPending: 'Pending',
          statusSuspended: 'Suspended',
          statusRejected: 'Rejected',
          searchPlaceholder: 'Search by name, email or company...',
          backToDashboard: 'Back to Admin Dashboard',
          export: 'Export',
          newUser: 'New User',
          userType: 'User Type',
          status: 'Status',
          reset: 'Reset'
        }
      },
      // ===== SUPPORT PAGE (EN) =====
      support: {
        page: {
          title: 'Technical Support',
          subtitle: 'Our team is available to help you',
          badge: 'Technical Support',
          technical: {
            title: 'Technical Support',
            desc: 'Technical issues, bugs, or platform usage difficulties.',
            action: 'Contact Support'
          },
          commercial: {
            title: 'Commercial Support',
            desc: 'Questions about pricing, partnerships, or event information.',
            action: 'Commercial Contact'
          },
          exhibitor: {
            title: 'Exhibitor Support',
            desc: 'Help with profile creation, stand management, or exhibitor features.',
            action: 'Exhibitor Support'
          },
          faqTitle: 'Frequently Asked Questions',
          faqLoginTitle: 'Login Problems',
          faqLoginQ1: 'I forgot my password',
          faqLoginA1: 'Use the "Forgot Password" link on the login page.',
          faqLoginQ2: 'My account is not activated',
          faqLoginA2: 'Check your emails or contact support for activation.',
          contactTitle: 'Need immediate help?',
          contactDesc: 'Our support team is available to answer all your questions.',
          contactTicket: 'Open a ticket',
          contactEmail: 'Send an email'
        }
      },
      // ===== 10 FILES BATCH 2 (EN) =====
      unauthorized: {
        access_denied: 'Unauthorized',
        login_redirect: 'Please log in to access',
        go_login_link: 'Go to login'
      },
      terms: {
        acceptance: 'By accessing and using the SIPORTS 2026 platform, you agree to be bound by these terms of use',
        dont_accept: 'If you do not accept these terms, please do not use our platform',
        service_desc: 'SIPORTS 2026 is a digital platform that facilitates professional connections',
        registration_conditions: 'To use our platform, you must',
        min_age: 'Be at least 18 years old',
        acceptable_use: 'You agree to use the platform responsibly and not to',
        ip_rights: 'All SIPORTS 2026 platform content is protected by copyright',
        our_responsibilities: 'Our responsibilities',
        your_responsibilities: 'Your responsibilities',
        termination_clause: 'We reserve the right to suspend or terminate your account if'
      },
      privacy: {
        data_collection: 'SIPORTS 2026 collects the following information when you use our platform',
        data_usage: 'Your data is used for',
        data_sharing: 'We do not sell your personal data',
        security_measures: 'We implement appropriate security measures to protect your data',
        gdpr_rights: 'In accordance with GDPR, you have the following rights',
        data_retention: 'We retain your data as long as necessary for',
        cookies_usage: 'We use cookies to improve your experience'
      },
      partnership: {
        title: 'SIPORTS 2026 Partnerships',
        desc: 'Join the international port ecosystem and gain exceptional visibility with industry decision-makers',
        premium_partner: 'Premium Partner',
        technical_partner: 'Technical Partner',
        media_partner: 'Media Partner',
        benefits: 'Partnership Benefits',
        international_visibility: 'International Visibility',
        roi_return: 'Return on Investment',
        contact_section: 'Ready to join us?',
        contact_description: 'Contact our sales team to discuss your partnership project'
      },
      reset_password: {
        title: 'Reset Password',
        link_expired: 'The reset link appears to be incomplete or expired',
        new_password_label: 'New Password',
        password_min_length: 'Password must be at least 12 characters',
        confirm_password_label: 'Confirm Password',
        passwords_not_match: 'Passwords do not match',
        success: '✅ Password set successfully. You can now log in',
        change_btn: 'Change Password'
      },
      signup_confirmation: {
        exhibitor_success: 'Exhibitor Registration Successful!',
        partner_success: 'Partner Registration Successful!',
        free_badge_password: '📧 Free Badge + Password Setup',
        email_verification: 'Check your email',
        email_sent_to: 'We sent a confirmation email to',
        spam_warning: 'Can\'t find the email? Check your spam or junk folder',
        need_help: 'Need help?',
        validation_in_progress: 'Validation in progress',
        resend_email_btn: 'Resend email',
        go_home: 'Back to home'
      },
      registration_success: {
        account_created: '✅ Account created!',
        registration_success: 'Registration successful!',
        congratulations: 'Congratulations! Your visitor account has been successfully created',
        account_pending: 'Your account is pending validation',
        features_access: 'You have access to',
        exhibitor_catalog: 'Complete exhibitor catalog',
        conference_program: 'Conference program',
        meeting_planning: 'Meeting planning',
        professional_network: 'Professional network'
      },
      dashboard_page: {
        unauthorized_access: 'Unauthorized access',
        login_dashboard: 'Please log in to access your dashboard',
        unknown_user_type: 'Unknown user type',
        contact_support: 'Contact support to resolve this issue'
      },
      subscription: {
        visitor_free: 'Free Visitor',
        free_access: 'Basic fair access',
        visitor_vip: 'Premium Visitor',
        vip_priority: 'Priority access + 10 meetings',
        exhibitor_9m: 'Exhibitor 9m² (Base)',
        exhibitor_18m: 'Exhibitor 18m² (Standard)',
        exhibitor_36m: 'Exhibitor 36m² (Premium)',
        exhibitor_54m: 'Exhibitor 54m²+ (Elite)',
        partner_museum: 'Museum Partner (20k$)',
        partner_silver: 'Silver Partner (48k$)',
        partner_gold: 'Gold Partner (68k$)',
        signup_free: 'Sign up for free',
        mini_site: 'Customized mini-site',
        unlimited_meetings: 'Unlimited meetings'
      },
      profile_matching: {
        ai_optimization: 'AI Optimization',
        ai_premium_only: 'Smart matching configuration is reserved for Premium and VIP members',
        improve_profile: 'Upgrade your profile to get ultra-relevant recommendations',
        discover_premium: 'Discover Premium offers',
        company_size_1_10: '1-10 employees',
        company_size_1000_plus: '1000+ employees',
        go_back: 'Back'
      }
    }
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
